import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle  } from 'react';
import {TabulatorFull as Tabulator} from "tabulator-tables"; //import Tabulator library
import "tabulator-tables/dist/css/tabulator_simple.min.css"; //import Tabulator stylesheet
import '../../assets/Styles/GridCSS/gridControl.css';
import { useDispatch, useSelector } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import APICom from "../../utils/helpers/APICom";
import ColumnChooser from './ColumnChooser';
import { faLessThan } from '@fortawesome/free-solid-svg-icons';
import { Modal, Button, ModalTitle, ProgressBar } from 'react-bootstrap';
import arrowUp from "../../assets/Images/MapImages/arrowUp.png";
import arrowDown from "../../assets/Images/MapImages/arrowDown.png";
import addbreaktripIcon from "../../assets/Images/MapImages/AddBreak.png";
import { DateTime } from 'luxon';
import {Col} from 'react-bootstrap';

const GridControl = forwardRef((props = {}, ref) => {
    const RefDispatchGridToolboxValues = useRef({});
    const [DispatchGridToolboxValues, SetDispatchGridToolboxValues] = useState({
        Date:"", AffiliatesList:"",FSList:"",AttrList:"", StatusList:"", TotalHours: 24
    });    
    const [WidthFromParent, setWidthFromParent] = useState("");
    useImperativeHandle(ref, () => ({
        ToolboxUpdate(_Toolbox) {
            SetDispatchGridToolboxValues(_Toolbox);
            RefDispatchGridToolboxValues.current = _Toolbox;
            PrepareGridRequestDispatch(_Toolbox);
        },
        SetWidth(_width){
            setWidthFromParent(_width);
        }
      }));
    let state = {
        height: 'auto',
        heightoffset: 183,
        paginationSize: props.options.paginationSize,
        pagination: true,
        paginationMode: "local",
        selectable: true,
        reactiveData:true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        GridName:"tabulator",
        paginationCounter:"rows",
        movableColumns:true,
        

        bForWeb: true,
        ID_Column: "",
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns: [],
        GridGroupedColumns: [],
        UseInternalGridDataReloadFunction: false,
    };
    const RefTable = useRef(null);
    const RefTableData = useRef([]);
    const RefProps = useRef(props);
    const RefSelectedRows = useRef([]);
    const GridRefreshTimerSecs = useRef(0);
    const RefGridMainDiv = useRef(null);
    const xCancelSourceForGrid = useRef(null);
    const iDispatchRequestCountUnderProgress = useRef(0);

    state = {...state, ...props.options, ...props.Filters, ...props.Data};
    const dispatch = useDispatch();
    const PrepareGridRequestDispatch = async (UserRequestParameters) => {
        if(typeof UserRequestParameters === "undefined"){
            UserRequestParameters = RefDispatchGridToolboxValues.current;
        }
        APICom.LastGridCall = new Date();
        if(UserRequestParameters === null) return;
        if(UserRequestParameters.Date === "" || UserRequestParameters.AffiliatesList === ""){ return; }

        // if (UserRequestParameters.Date !== ""){
        //     RefSelectedDate.current = UserRequestParameters.Date; //saving DOM selected date because we need this when showing cluster grid. If not saved here it shows empty date
        // }

        try {
            
            if(xCancelSourceForGrid.current != null) { 
                xCancelSourceForGrid.current.cancel("Cancelling grid request fetch call before initiating new request");
            }
        } catch(e) { }
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let iRoutedTrip = 0;
        try{
            if(UserRequestParameters.Grouping === ""){
                iRoutedTrip = 0;
            }
            else if(UserRequestParameters.Grouping.indexOf(",") < 0) {
                iRoutedTrip = parseInt(UserRequestParameters.Grouping);
            }
        }
        catch(e) { }
        const data = {
            "date": UserRequestParameters.Date,
            "aff_list": (UserRequestParameters.AffiliatesList === "" ? "999" : UserRequestParameters.AffiliatesList),
            "FSList": UserRequestParameters.FSList,
            "user_id": loginData.iUserID,
            "statusArr": UserRequestParameters.StatusList,
            "attrArray": UserRequestParameters.AttrList,
            "iRoutedTrip": iRoutedTrip,
            "ihoursInFuture": UserRequestParameters.TotalHours,
            "SendJSONResponse": true
        }
        setShowGridLoader(true);
        
        // console.log("Grid Data Reloaded from dispatch");
        iDispatchRequestCountUnderProgress.current = iDispatchRequestCountUnderProgress.current  + 1;
        APICom.fetchData("main", "GridData/GetSRQARQPRQGridData", "post", {}, data, xCancelSourceForGrid.current, true).then((response) => {
            APICom.LastGridCall = new Date();
            iDispatchRequestCountUnderProgress.current = iDispatchRequestCountUnderProgress.current  - 1;
            if(iDispatchRequestCountUnderProgress.current <= 0){
                setShowGridLoader(false);
            }
            if(response.error === ""){
                //setDispatchGridResponse({"data" : response.data});
                getGridDataFormat(response.data);
            }
            else{
            }
        });
        
    }
    /*useEffect(() => {
        if(typeof props.UserRequestParameters !== "undefined"){
           setTimeout(() => {
            PrepareGridRequestDispatch();
           }, 5000); 
        }
        return () => {
            try {
                if(xCancelSourceForGrid.current !== null){
                    xCancelSourceForGrid.current.cancel("Cancelling grid request fetch call before initiating new request");
                }
            } catch(e) { }
        };
    },[props.UserRequestParameters]);*/
    const [ProgressBarCurrentValue, setProgressBarCurrentValue] = useState(0);
    const [ProgressBarCurrentLabel, setProgressBarCurrentLabel] = useState("");
    const { SessionPersistData } = useSelector((store) => store.apicommunication);
    const [defaultModal, setDefaultModal] = useState({ title:"Action Modal"});
    const [ColumnModel, setColumnModel] = useState([]);
    const [ClusterTableColumnModel, setClusterTableColumnModel] = useState([]);
    const [BackupTable, setBackupTable] = useState([]);
    const [TableData, setTableData] = useState([]);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [showModal, setShowModal] = useState(false);
    const [SelectedRoute, setSelectedRoute] = useState("");
    const verticalPosScroller = useRef(0);
    const afterRenderScrollerPos = useRef(0);
    const SelectedRouteT = useRef("");
    const rowPosDrag = useRef(0);
    const rowIndexDrag = useRef("");
    const rowsPosMovementArr = useRef([]);
    const { loginData } = useSelector((store) => store.login);
    // const refreshGroupList = useRef([]);
    // const [scrollerVerticalPos, setVerticalScrollerPos] = useState(0);
    // const [scrollerHorizontalPos, setHorizontalScrollerPos] = useState(0);
    const [modalBodyText, setModalBodyText] = useState("");
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBtnText, setModalBtnText] = useState("");
    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const [replacementContextOptions, setReplacementContextOptions] = useState(React.cloneElement([], {...state.contextMenuSetting}));
    const handleModalClose = () => {
        setShowModal(false);
    };
    
    const handleResize = () => {
        setWindowHeight(window.innerHeight);
    };

    const handleDuplicates = (dict, title) =>
    {
        try{
            // Declare a new array
            let newArray = [];
                        
            // Declare an empty object
            let uniqueObject = {};
    
            for(var j in dict)
            {
                // Extract the title
                let objTitle = dict[j][title];
                
                // Use the title as the index
                uniqueObject[objTitle] = dict[j];
            }
           
            // Loop to push unique object into array
            for (var u in uniqueObject) {
                newArray.push(uniqueObject[u]);
            }
            // Display the unique objects
            
            return newArray;
        }
        catch(err){console.log(err);}
    };

    let table = null;

    //define row context menu contents
    
    //define column header menu as column visibility toggle
	var headerMenu = function(){
		let menu = [];
		let columns = this.getColumns();
        let columnDefCheck = columns[0].getDefinition().field === "Drag" ? true:false;

        if(columns[0].getDefinition().title === "Attribute")
        {
            columns.splice(0,1);
        }
        
        if(columnDefCheck && columns[1].getDefinition().title === "Actions")
        {
            columns.splice(0,2);
        }
        else if(!columnDefCheck && columns[0].getDefinition().title === "Actions")
        {
            columns.splice(0,1);
        }
        let thisvar = this;

        
        
        let btnLabel = document.createElement("span");
        let spacingDiv = document.createElement("div");
        let spacingDiv2 = document.createElement("div");
        let colCounterLabel = document.createElement("span");
        let colCounterSpan = document.createElement("span");
        if(state.saveCCSettingsOption)
        {
            let fitlerInput = document.createElement("input");
            let factoryConfigBtn = document.createElement("button");
            let visibleBtn = document.createElement("button");
            let saveUserSettingsBtn = document.createElement("button");
    
            factoryConfigBtn.type = "button";
            saveUserSettingsBtn.type = "button";
            visibleBtn.type = "button";
    
            visibleBtn.textContent = "Invisible Columns";
            factoryConfigBtn.textContent = "Default Settings";
            saveUserSettingsBtn.textContent = "Save Settings";
    
            factoryConfigBtn.id = state.GridName+"_factoryResetBtn";
            saveUserSettingsBtn.id = state.GridName+"_saveUserSettingsBtn";
            visibleBtn.id = state.GridName+"_visibilityBtn";
            fitlerInput.id = state.GridName+"_ColumnChooserFilterInput";

            fitlerInput.autocomplete = "off";
            fitlerInput.placeholder = "Search";

            factoryConfigBtn.className ="btn btn-secondary mx-auto";
            saveUserSettingsBtn.className ="btn btn-secondary mx-auto";
            visibleBtn.className ="btn btn-secondary mx-auto";
            fitlerInput.className ="tabulator-header-filter mx-auto w-100";

            menu.push({
                label: fitlerInput,
               
                action: function(e){
                    //prevent menu closing
                    e.stopPropagation();
                    if(document.getElementById(state.GridName+"_visibilityBtn").textContent.toLowerCase().includes("all"))
                    {
                        document.getElementById(state.GridName+"_visibilityBtn").click();
                    }
                    document.getElementById(state.GridName+"_ColumnChooserFilterInput").addEventListener("keyup", handleSearch);
                }
            });

            btnLabel.appendChild(factoryConfigBtn);
            btnLabel.appendChild(spacingDiv);
            btnLabel.appendChild(visibleBtn);
            btnLabel.appendChild(spacingDiv2);
            btnLabel.appendChild(saveUserSettingsBtn);
        }
        else
        {
            let fitlerInput = document.createElement("input");
            fitlerInput.id = state.GridName+"_ColumnChooserFilterInput";

            fitlerInput.autocomplete = "off";
            fitlerInput.placeholder = "Search";
            fitlerInput.className ="tabulator-header-filter mx-auto w-100";

            menu.push({
                label: fitlerInput,
               
                action: function(e){
                    //prevent menu closing
                    e.stopPropagation();
                    document.getElementById(state.GridName+"_ColumnChooserFilterInput").addEventListener("keyup", handleSearch);
                }
            });
        }
        

        colCounterSpan.id = state.GridName+"_colCounterLabel";
        
        btnLabel.className = "d-flex";
        colCounterLabel.className = "d-flex justify-content-center";
        spacingDiv.className = "p-1";
        spacingDiv2.className = "p-1";

        menu.push({
            label: btnLabel,
            action: async function(e){
                //prevent menu closing
                e.stopPropagation();
                if(e.target.id === state.GridName+"_factoryResetBtn")
                {
                    //factory reset columns settings function here
                    xCancelSourceForGrid.current = APICom.GenerateSource();
                    const data = {
                        "vGridName": state.vDefaultGridName,
                        "bForWeb": state.bForWeb,
                        "LoginUserID": '-1',
                        "bSysUser": state.bSysUser
                    };
                    try{
                        let response = await APICom.fetchData("main", "GridColConfigs/GetGridViewSettingCol", "post", {}, data, xCancelSourceForGrid.current);
                        try{
                            let colmns = []
                            for(var j = 0; j < response.data.length; j++)
                            {
                                if(state.AlwaysHiddenColumns.indexOf(response.data[j]["vName"]) > -1)
                                {
                                    colmns.push({ title: response.data[j]["vName"], field: response.data[j]["vName"].replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "center", visible: false, headerMenu:headerMenu, width: response.data[j]["iWidth"], headerSortTristate:true}); //, hidden: ((colVisibility_.toLocaleLowerCase() === "true" || colVisibility_.toLocaleLowerCase() === "true@$@" || colVisibility_.toLowerCase() === "true@$@@$@") ? false : true
                                }
                                else if(state.AlwaysHiddenColumns.indexOf(response.data[j]["vName"]) === -1)
                                {
                                    colmns.push({ title: response.data[j]["vName"], field: response.data[j]["vName"].replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "center", visible: response.data[j]["bVisible"], headerMenu:headerMenu, width: response.data[j]["iWidth"], headerSortTristate:true}); //, hidden: ((colVisibility_.toLocaleLowerCase() === "true" || colVisibility_.toLocaleLowerCase() === "true@$@" || colVisibility_.toLowerCase() === "true@$@@$@") ? false : true)
                                }
                            }
                            thisvar.setColumns(colmns);
                        }
                        catch(e) { }
                        try{
                            /*
                            for(let column of columns)
                            {
                                
                                for(var j = 0; j < response.data.length; j++)
                                {
                                    if(response.data[j]["vName"] === column.getDefinition().title)
                                    {
                                        if(column.isVisible() !== response.data[j]["bVisible"])
                                        { 
                                            column.toggle(); 
                                        }
                                    }
                                    
                                }
                                
                            }
                            */
                            document.getElementsByClassName("tabulator-popup-container")[0].style.display = "none";
                            
                        }
                        catch(err){}
                    }
                    catch(err){}
                }
                else if(e.target.id === state.GridName+"_visibilityBtn")
                {
                    var elements = document.getElementsByClassName('tabulator-menu-item');
                    let counter = 0;
                    if(document.getElementById(state.GridName+"_visibilityBtn").textContent.toLowerCase().includes("invisible"))
                    {
                        
                        for(var k = 3; k < elements.length; k++)
                        {
                            if(elements[k].children[0].children[0].textContent === "✔")
                            {
                                elements[k].style.display = "none";
                            }
                            else
                            {
                                elements[k].style.display = "block";
                                counter+=1;
                            }
    
                        }
                        document.getElementById(state.GridName+"_visibilityBtn").textContent = "Visible Columns";
                        document.getElementById(state.GridName+"_colCounterLabel").textContent = "Column #: "+ counter;
                    }
                    else{
                        
                        for(var k = 3; k < elements.length; k++)
                        {
                            // if(elements[k].style.display === "none")
                            // {
                            //     elements[k].style.display = "block";
                            //     counter+=1;
                            // }
                            if(elements[k].children[0].children[0].textContent === "❌")
                            {
                                elements[k].style.display = "none";
                            }
                            else
                            {
                                elements[k].style.display = "block";
                                counter+=1;
                            }
                            
                        }
                        document.getElementById(state.GridName+"_visibilityBtn").textContent = "Invisible Columns";
                        document.getElementById(state.GridName+"_colCounterLabel").textContent = "Visible Column #: "+ counter;
                    }
                    
                }
                else if(e.target.id === state.GridName+"_saveUserSettingsBtn")
                {
                    document.getElementById(state.GridName+"_saveUserSettingsBtn").textContent = "Saving ...";
                    //save user settings
                    try {
                        let _ii = 0;
                        let _iiVisibleIdx = 1;
                        let colsarray = [];
                        for(let column of columns)
                        {
                            if(state.AlwaysHiddenColumns.indexOf(column.getDefinition().title) === -1)
                            {
                                let __PcolVisible = false;
                                __PcolVisible = column.isVisible();
                                let __PcolSettingIndex = -1;
                                if(__PcolVisible){
                                    __PcolSettingIndex = _iiVisibleIdx;
                                    _iiVisibleIdx = _iiVisibleIdx + 1;
                                }
                                colsarray.push({
                                    "colSettingIndex": __PcolSettingIndex,
                                    "bVisible": __PcolVisible,
                                    "colName": column.getDefinition().title,
                                    "gridSettingName": state.vDefaultGridName,
                                    "LoginUserID": loginData.iUserID,
                                    "iWidth": column.getWidth() ?? -1,
                                    "bWebApplySettingToAll": false//state.bWebApplySettingToAll
                                });
                                _ii = _ii + 1;
                            }
                        }
                        
                        try{
                            xCancelSourceForGrid.current = APICom.GenerateSource();
                            const data = {
                                "gridSettingsColCounter": _ii,
                                "bWebGrid": state.bForWeb,
                                "gridName": state.vDefaultGridName,
                                "LoginUserID": loginData.iUserID,
                                "bWebApplySettingToAll": false//state.bWebApplySettingToAll
                            };
                            await APICom.fetchData("main", "GridColConfigs/InsertUpdatedGridMainSettings", "post", {}, data, xCancelSourceForGrid.current);
                            await new Promise(resolve => setTimeout(resolve, 5000));
                            xCancelSourceForGrid.current = APICom.GenerateSource();
                            await APICom.fetchData("main", "GridColConfigs/InsertUpdatedGridSettingsCol", "post", {}, colsarray, xCancelSourceForGrid.current);
                        }
                        catch(err){}
                    }
                    catch(e){   }
                    if(document.getElementById(state.GridName+"_saveUserSettingsBtn").textContent)
                        document.getElementById(state.GridName+"_saveUserSettingsBtn").textContent = "Save Settings";
                    /*
                    try{
                        let i = 0;
                        for(let column of columns)
                        {
                            if(column.isVisible())
                            {
                                xCancelSourceForGrid.current = APICom.GenerateSource();
                                var data = {
                                    "colSettingIndex": i,
                                    "bVisible": state.bForWeb,
                                    "colName": column.getDefinition().title,
                                    "gridSettingName": state.vDefaultGridName,
                                    "LoginUserID": loginData.iUserID,
                                    "bWebApplySettingToAll": state.bWebApplySettingToAll
                                };
                                await APICom.fetchData("main", "GridColConfigs/InsertUpdatedGridSettingsCol", "post", {}, data, xCancelSourceForGrid.current);
                            }
                            i += 1;
                            
                        }
                        
                    }
                    catch(err){} 
                    */
                    document.getElementsByClassName("tabulator-popup-container")[0].style.display = "none";
                }
                
            }
        });
        let visibleColCounter = 0;
        let invisibleColCounter = 0;
        let allCols = 0;
        menu.push({
            label: colCounterLabel,
            action: function(e){
                //prevent menu closing
                e.stopPropagation();
            }
        });
        
		for(let column of columns){

            let icon = document.createElement("i");
            let label = document.createElement("span");
            let title = document.createElement("span");
            if(state.AlwaysHiddenColumns.indexOf(column.getDefinition().title) === -1)
            {
                //create checkbox element using font awesome icons
                
                icon.textContent = column.isVisible() ? "✔" : "❌";

                visibleColCounter = column.isVisible() ? (visibleColCounter+1): visibleColCounter;
                invisibleColCounter = column.isVisible() ? invisibleColCounter: (invisibleColCounter+1);
                allCols = allCols+1;
                //build label
                

                title.textContent = " " + column.getDefinition().title;
                label.id = column.getDefinition().title+"_ColChooser";
                label.appendChild(icon);
                label.appendChild(title);
            }
            
            if(label.hasChildNodes())
            {
                //create menu item
                menu.push({
                    label:label,
                    action:function(e){
                        //prevent menu closing
                        e.stopPropagation();
                        //toggle current column visibility
                        column.toggle();
                        visibleColCounter = column.isVisible() ? (visibleColCounter+1): (visibleColCounter-1);
                        invisibleColCounter = column.isVisible() ? (invisibleColCounter-1): (invisibleColCounter+1);
                        if(state.saveCCSettingsOption) //saving option for grid columns
                        {
                            document.getElementById(state.GridName+"_factoryResetBtn").disabled = false;
                            document.getElementById(state.GridName+"_saveUserSettingsBtn").disabled = false;
                            if(document.getElementById(state.GridName+"_visibilityBtn").textContent.toLowerCase().includes("invisible"))
                            {
                                document.getElementById(state.GridName+"_colCounterLabel").textContent = "Visible Column #: "+ visibleColCounter;
                            }
                            else
                            {
                                document.getElementById(state.GridName+"_colCounterLabel").textContent = "Column #: "+ invisibleColCounter;
                            }
                        }
                        else
                        {
                            document.getElementById(state.GridName+"_colCounterLabel").textContent = "Visible Column #: "+ visibleColCounter;
                        }
                        // document.getElementById(state.GridName+"_colCounterLabel").textContent = "Visible Column #: "+ visibleColCounter;
                        //change menu item icon
                        if(column.isVisible()){
                                icon.textContent = "✔";
                        }else{
                                icon.textContent = "❌";
                        }
                    }
                });
            }
            
		}
        colCounterSpan.textContent = "Visible Column #: "+ visibleColCounter;
        colCounterLabel.appendChild(colCounterSpan);
        

	    return menu;
	};
    function handleSearch(e){
        var elements = document.getElementsByClassName('tabulator-menu-item'); //[0].children[0]
        
        for(var k = 3; k < elements.length; k++)
        {
            if(!elements[k].children[0].id.replace("_ColChooser","").toLowerCase().includes(e.target.value.toLowerCase()))
            {
                elements[k].style.display = "none";
            }
            else
            {
                elements[k].style.display = "block";
            }

        }
       
    }
    const PreserveTheSelectedRows = async() => {
        let selected = RefTable.current.getSelectedRows();
        let tempRows = [];
        for(let k in selected)
        {
            tempRows.push(selected[k].getData()[state.index]);
        }
        RefSelectedRows.current = tempRows;
    }
    const ApplyPreservedRowsSelection = async() => {
        RefTable.current.selectRow(RefSelectedRows.current);
    }

    const getGridDataFormat = async (data) => {
        // if(RefTableData.current.length > 1000) {
        //     // console.log("1000row");
        //     //return;
        // }
        let tableData = [];
        let RequestDataForGridInitialize = "";
        try {
            var dict = {};
            if (data !== null && typeof data === 'object' && !Array.isArray(data)) {
                RequestDataForGridInitialize = data.TripsJSON;
                data = data.Settings;
            }
            else {
                if (data.indexOf("|*|") > -1) {
                    if (data.split("|*|").length === 3) {
                        try {
                            RequestDataForGridInitialize = JSON.parse(data.split("|*|")[2]);
                        }
                        catch (mnk) { }
                        // data1 = data.split("|*|")[0];
                        data = data.split("|*|")[1];
                    }
                    else {
                        try {
                            RequestDataForGridInitialize = JSON.parse(data.split("|*|")[1]);
                        }
                        catch (mnk) { }
                        // data1 = data.split("|*|")[0];
                        data = data.split("|*|")[0];
                    }

                }
            }

            for (var u = 0; u < RequestDataForGridInitialize.length; u++) {
                dict = {};
                dict["id"] = u;
                for (var k of Object.keys(RequestDataForGridInitialize[u])) {
                    if (k.toUpperCase() === "ATTRIBUTE") {
                        //dict[k] = "<div class='d-inline-flex' style='height:14px'>"+RequestDataForGridInitialize[u][k]+"</div>";
                        dict[k] = RequestDataForGridInitialize[u][k] + "";
                    }
                    else {
                        dict[k] = RequestDataForGridInitialize[u][k];
                    }
                }
                tableData.push(dict);
            }

            if (RefTable.current !== null && tableData.length > 0) {
                if (state.GridName === "tabulator") {
                    /*
                    await PreserveTheSelectedRows();
                    await RefTable.current.replaceData(tableData)
                    .then(function(){
                        setTimeout(() => {
                            RefTable.current.rowManager.element.scrollTop = afterRenderScrollerPos.current;
                        }, 4);
                    })
                    .catch(function(err){
                        console.log(err);
                    });
                    */
                    compareAndUpdateArrays(tableData);
                    props.GridLoadComplete();



                }
                else {
                    RefTable.current.replaceData(tableData);
                }
            }
            else if (RefTable.current !== null && tableData.length === 0) {
                if (state.GridName === "tabulator") {
                    //RefTable.current.replaceData(tableData);
                    compareAndUpdateArrays(tableData);
                    props.GridLoadComplete();
                }
                else {
                    RefTable.current.replaceData(tableData);
                }

            }
            //if(TableData.length === 0) {
                setTableData(tableData);
            //}
            if(ColumnModel.length === 0 && data && data.length > 0) {
                setColumnModel(BuildColumnModel(data));
            }
            else
            {
                // setColumnModel([]);
            }
            RequestDataForGridInitialize = null;
            tableData = null;
            data = null;
        }
        catch (err) { console.log("An error occured on getting IDR data.", err); }
    }
    const BuildColumnModel = (cols) => {
        var uFields = cols.split(',');
        var columns = [];
        try 
        {
            let frozenIndex = uFields.findIndex((item)=>{if(item.split("~")[0] === "Attribute"){return item;}});
            if(frozenIndex > -1)
            {
                const temp = uFields[0];
                uFields[0] = uFields[frozenIndex];
                uFields[frozenIndex] = temp;
            }
            for (var i = 0; i < uFields.length; i++) {
                    
                var colname_ = uFields[i].split("?")[0];
                
                var colfrozen_ = false;
                var colDataType_ = "text"; //This Type will be used for sorting while the other will be used for filtering
                try {
                    if (colname_.indexOf("|") > -1) {
                        try {
                            
                            colname_ = colname_.replace("|" + colDataType_, "");
                        } catch (Error) { }
                    }
                }
                catch (err55) { }
                if (colname_.indexOf("~") > -1) {
                    try {
                        colfrozen_ = (colname_.split("~")[1] === "true") ? true : false;
                        colname_ = colname_.replace("~" + colname_.split("~")[1], "");
                    } catch (Error) { }
                }
                let pcolVisible = true;
                let pcolWidth = 120;
                try {
                    pcolVisible = (uFields[i].split("?")[3] == "true" ? true : false);
                }
                catch (pError) { }
                try {
                    pcolWidth = parseInt(uFields[i].split("?")[2]);
                }
                catch (pError) { }
                
                if(state.AlwaysHiddenColumns.indexOf(uFields[i].split("?")[0].split("~")[0]) > -1)
                {
                    if(colname_ === "Attribute")
                    {
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: false, width: pcolWidth, formatter:"html", headerSortTristate:true, frozen: state.frozenState}); //, hidden: ((colVisibility_.toLocaleLowerCase() === "true" || colVisibility_.toLocaleLowerCase() === "true@$@" || colVisibility_.toLowerCase() === "true@$@@$@") ? false : true
                    }
                    else if(colname_.toLowerCase().includes("datetime"))
                    {
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), sorter:function(a,b){
                            let firstTime = DateTime.fromFormat(a.replace(/\s/g, ''),'MM/dd/yyyyh:mma');
                            let secondTime = DateTime.fromFormat(b.replace(/\s/g, ''), 'MM/dd/yyyyh:mma');
                            return firstTime-secondTime;
                        }, headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: true, headerMenu:headerMenu, width: pcolWidth, headerSortTristate:true});
                    }
                    else if(colname_ === "TripRequestStatus" || colname_ === "PUETA" || colname_ === "DOETA" || colname_ === "Affiliate" || colname_ === "RequestType" || colname_ === "FundingSource" || colname_ === "Created By")
                    {
                        
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: pcolVisible, headerMenu:headerMenu, width: pcolWidth, headerSortTristate:true, formatter: function(cell){
                            
                            try{
                                if(typeof RefProps.current.cellColors !== "undefined"){
                                    var value = cell.getValue();
                                    for(var k = 0; k < RefProps.current.cellColors.length; k++)
                                    {
                                        if(value && (value !== null || value !== ""))
                                        {
                                            if(cell.getColumn().getDefinition().title.toUpperCase() === "TRIPREQUESTSTATUS")
                                            {
                                                if((RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").includes(cell.getColumn().getDefinition().title) || RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").toUpperCase().includes("TRIPSTATUS")) && RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").toUpperCase().includes(value.replace(/ /g, "").replace(/^(NOSHOW)$/, "NOSHOWED").toUpperCase()))
                                                {
                                                    cell.getElement().style.backgroundColor = RefProps.current.cellColors[k].vHexColorCode;
                                                    cell.getElement().style.color = RefProps.current.cellColors[k].vHexForeColorCode;
                                                }
                                            }
                                            else if((RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").includes(cell.getColumn().getDefinition().title)) && RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").toUpperCase().includes(value.replace(/ /g, "").replace(/^(NOSHOW)$/, "NOSHOWED").toUpperCase()))
                                            {
                                                cell.getElement().style.backgroundColor = RefProps.current.cellColors[k].vHexColorCode;
                                                cell.getElement().style.color = RefProps.current.cellColors[k].vHexForeColorCode;
                                                // cell.getElement().css({"background-color": props.cellColors[k].vHexColorCode, "color":props.cellColors[k].vHexForeColorCode});
                                            }
                                        }
                                        


                                        // if(props.cellColors[k].vDisplayName.includes("FundingSource") && value === "MCPS")
                                        // {
                                        //     console.log("tea");
                                        //     // cell.getElement().css({"background": props.cellColors[k].vHexColorCode});
                                        //     cell.getElement().style.backgroundColor = props.cellColors[k].vHexColorCode;
                                        // }
                                    }
                                }
                            }
                            catch(err){console.log(err);}
                            
                            return value;
                        }});
                    }
                    else
                    {
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: false, headerMenu:headerMenu, width: pcolWidth, headerSortTristate:true}); 
                    }
                }
                else if(state.AlwaysHiddenColumns.indexOf(uFields[i].split("?")[0].split("~")[0]) === -1)
                {
                    if(colname_ === "Attribute")
                    {
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: true, width: pcolWidth, formatter:"html", headerSortTristate:true, frozen: state.frozenState});
                    }
                    if(colname_ === "VEHNo") {
                        columns.push({title: colname_, field: colname_.replace(" ", ""), headerFilter: true, headerHozAlign: "center", hozAlign: "left", visible: pcolVisible,
                            headerMenu: headerMenu, width: pcolWidth, headerSortTristate: true,
                            headerFilterFunc: function(headerValue, rowValue) {
                                // Check if the headerValue contains percent signs for wildcard matching
                                if (headerValue.startsWith("%") && headerValue.endsWith("%")) {
                                    // Perform a "contains" match (i.e., match anywhere within the row value)
                                    const cleanValue = headerValue.slice(1, -1).toLowerCase(); // Remove both % signs
                                    return rowValue.toLowerCase().includes(cleanValue);
                                }
                                else if (headerValue.startsWith("%")) {
                                    // Perform an "ends with" match
                                    const cleanValue = headerValue.slice(1).toLowerCase(); // Remove the starting %
                                    return rowValue.toLowerCase().endsWith(cleanValue);
                                }
                                else if (headerValue.endsWith("%")) {
                                    // Perform a "starts with" match
                                    const cleanValue = headerValue.slice(0, -1).toLowerCase(); // Remove the ending %
                                    return rowValue.toLowerCase().startsWith(cleanValue);
                                }
                                else {
                                    // Perform an exact match if no percent signs are used
                                    return rowValue.toLowerCase() === headerValue.toLowerCase();
                                }
                            }
                        });
                    }
                    
                    else if(colname_.toLowerCase().includes("datetime"))
                    {
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), sorter:function(a,b){
                            let firstTime = DateTime.fromFormat(a.replace(/\s/g, ''),'MM/dd/yyyyh:mma');
                            let secondTime = DateTime.fromFormat(b.replace(/\s/g, ''), 'MM/dd/yyyyh:mma');
                            return firstTime-secondTime;
                        }, headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: true, headerMenu:headerMenu, width: pcolWidth, headerSortTristate:true});
                    
                    }
                    else if(colname_ === "TripRequestStatus" || colname_ === "PUETA" || colname_ === "DOETA" || colname_ === "Affiliate" || colname_ === "RequestType" || colname_ === "FundingSource" || colname_ === "Created By")
                    {
                        
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: pcolVisible, headerMenu:headerMenu, width: pcolWidth, headerSortTristate:true, formatter: function(cell, formatterParams){
                            try{
                                
                                if(typeof RefProps.current.cellColors !== "undefined"){
                                    var value = cell.getValue();
                                    if(cell.getElement().style.color !== "") {
                                        cell.getElement().style.backgroundColor = "";
                                        cell.getElement().style.color = "";
                                    }
                                    for(var k = 0; k < RefProps.current.cellColors.length; k++)
                                    {
                                        
                                        if(value && (value !== null || value !== ""))
                                        {
                                            if(cell.getColumn().getDefinition().title.toUpperCase() === "TRIPREQUESTSTATUS")
                                            {
                                                
                                                if(RefProps.current.cellColors[k].vDisplayName && (RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").includes(cell.getColumn().getDefinition().title) || RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").toUpperCase().includes("TRIPSTATUS")) && RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").toUpperCase().includes(value.replace(/ /g, "").replace(/^(NOSHOW)$/, "NOSHOWED").toUpperCase()))
                                                {
                                                    cell.getElement().style.backgroundColor = RefProps.current.cellColors[k].vHexColorCode;
                                                    cell.getElement().style.color = RefProps.current.cellColors[k].vHexForeColorCode;
                                                }
                                            }
                                            else if(RefProps.current.cellColors[k].vDisplayName && (RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").includes(cell.getColumn().getDefinition().title)) && RefProps.current.cellColors[k].vDisplayName.replace(/ /g, "").toUpperCase().includes(value.replace(/ /g, "").replace(/^(NOSHOW)$/, "NOSHOWED").toUpperCase()))
                                            {
                                                cell.getElement().style.backgroundColor = RefProps.current.cellColors[k].vHexColorCode;
                                                cell.getElement().style.color = RefProps.current.cellColors[k].vHexForeColorCode;
                                                // cell.getElement().css({"background-color": props.cellColors[k].vHexColorCode, "color":props.cellColors[k].vHexForeColorCode});
                                            }
                                        }
                                        
                                    }
                                }
                                
                            }
                            catch(err){console.log(err);}
                            
                            return value;
                        }});
                    }
                    else
                    {
                        columns.push({ title: colname_, field: colname_.replace(" ", ""), headerFilter:true, headerHozAlign: "center", hozAlign: "left", visible: pcolVisible, headerMenu:headerMenu, width: pcolWidth, headerSortTristate:true}); //, hidden: ((colVisibility_.toLocaleLowerCase() === "true" || colVisibility_.toLocaleLowerCase() === "true@$@" || colVisibility_.toLowerCase() === "true@$@@$@") ? false : true)
                    }
                }
                
                
            }
            
        }
        catch (errorA4) { }
        return columns;
    };

    const keyPressHandler = (e)=>{
        try{
            if (RefGridMainDiv.current && RefGridMainDiv.current.contains(e.target)) {
                let selectedRow = table.getSelectedRows()[0];
                if(e.keyCode === 38)    //Up arrow
                {
                    e.preventDefault();
                    if(selectedRow !== undefined && selectedRow.getPrevRow() !== false)
                    {
                        table.deselectRow();
                        let prevRow = selectedRow.getPrevRow();
                        table.selectRow(prevRow);
                        let visibleRow = table.getRows("visible")[0];
                        // console.log(prevRow.getPosition(true), visibleRows);
                        if(prevRow.getIndex() === visibleRow.getIndex())
                        {
                            table.rowManager.element.scrollTop = prevRow.getElement().offsetTop-600;
                        }
                        
                    }
                    
                }
                else if(e.keyCode === 40)   //Down arrow
                {
                    e.preventDefault();
                    if(selectedRow !== undefined && selectedRow.getNextRow() !== false) 
                    {
                        table.deselectRow();
                        let nextRow = selectedRow.getNextRow();
                        table.selectRow(nextRow);
                        let visibleRow = table.getRows("visible")[table.getRows("visible").length-1];
                        // console.log(visibleRow.getIndex(), "next row:"+nextRow.getIndex());
                        if(nextRow.getIndex() === visibleRow.getIndex())
                        {
                            table.rowManager.element.scrollTop = nextRow.getElement().offsetTop-100;
                        }
                        
                    }
                    
                }
            }
        }
        catch(e) { }
    }

    const GetGridHeight = () => {
        let iheight = 100;
        if (props.height) {
            return '100%';
        }
        if (state.height === "auto")
        {
            if(state.calculateHeight === false)
            {
                iheight = state.height;
            }
            else
            {
                iheight = (windowHeight - state.heightoffset);
            }
        }
        else if(parseFloat(state.height) !== NaN)
            iheight = parseFloat(state.height);
        return iheight;
    }
    const compareAndUpdateArrays = (A2) => {
        console.time("compareAndUpdateArrays_ExecutionTime");
        //RefTableData.current.splice(0, RefTableData.current.length);
        //RefTableData.current.push(...A2);
        // Create a map for quick lookup in A2
        let setDataNameUpdated = false;
        if((RefTableData.current.length - A2.length) > 200 || (A2.length - RefTableData.current.length) > 200){
            RefTableData.current = A2;
            RefTable.current.setData(RefTableData.current);
            console.log("Array Updated using setData Main...");
            setDataNameUpdated = true;
        }
        else{
            let icntNew = 0;
            let icntUpd = 0;
            let icntRemoved = 0;
            const transformedObject = A2.reduce((obj, item) => {
                obj[item[state.ID_Column]] = item;
                return obj;
            }, {});
            for (let i = 0; i < RefTableData.current.length; i++) {
                if (typeof transformedObject[RefTableData.current[i][state.ID_Column]] === "undefined") {
                    icntRemoved++;
                }
            }
            let largePercentageRemoved = false;
            try{
                if(RefTableData.current.length === 0){
                    largePercentageRemoved = true;
                }
                else{
                    if(((icntRemoved / RefTableData.current.length) * 100) > 50){
                        largePercentageRemoved = true;
                    }
                }
            }
            catch(e) {

            }
            if(largePercentageRemoved){
                RefTableData.current = A2;
                RefTable.current.setData(RefTableData.current);
                console.log("Array Updated using setData Main, due to large records got removed...");
                setDataNameUpdated = true;
            }
            else{
                // Iterate over A1 and update or remove items based on A2
                for (let i = 0; i < RefTableData.current.length; i++) {
                    //if (mapA2.has(RefTableData.current[i][state.ID_Column])) {
                    if (typeof transformedObject[RefTableData.current[i][state.ID_Column]] !== "undefined") {
                        // Compare the entire object, replace if different
                        if (JSON.stringify(RefTableData.current[i]) !== JSON.stringify(transformedObject[RefTableData.current[i][state.ID_Column]])) {
                            icntUpd++;
                            //RefTableData.current.splice(i, 1, transformedObject[RefTableData.current[i][state.ID_Column]]);
                            for (let key in transformedObject[RefTableData.current[i][state.ID_Column]]) {
                                if (transformedObject[RefTableData.current[i][state.ID_Column]].hasOwnProperty(key)) {
                                    if(RefTableData.current[i][key] !== transformedObject[RefTableData.current[i][state.ID_Column]][key]){
                                        RefTableData.current[i][key] = transformedObject[RefTableData.current[i][state.ID_Column]][key];
                                    }
                                }
                            }
                        }
                        delete transformedObject[RefTableData.current[i][state.ID_Column]];
                    } else {
                        // Remove item from A1 if it's not in A2
                        RefTableData.current.splice(i, 1);
                        i--; // Adjust the index after removal
                    }
                }
                if(Object.keys(transformedObject).length > 30){
                    RefTableData.current = A2;
                    RefTable.current.setData(RefTableData.current);
                    console.log("Array Updated using setData Inner...");
                    setDataNameUpdated = true;
                }
                else{
                    const _Keys = Object.keys(transformedObject);
                    for (const key of _Keys) {
                        //RefTableData.current.push(transformedObject[key]);
                        icntNew++;
                        RefTableData.current.splice(RefTableData.current.length, 0, transformedObject[key]);
                    }
                }
                console.log("Array Updated using splice and push. Total Updates: " + icntUpd + ", Total Inserts: " + icntNew);
            }
        }
        if(setDataNameUpdated){
            let currentGroupBy = RefTable.current.getGroups();
            if(currentGroupBy.length !== 0)
            { 
                let key = currentGroupBy[0].getField();
                RefTable.current.setGroupBy(false);
                RefTable.current.setGroupBy(key);
            }
        }
        const currentFilters = RefTable.current.getFilters();
        RefTable.current.clearFilter();
        currentFilters.forEach(filter => { RefTable.current.setFilter(filter.field, filter.type, filter.value); });
        console.timeEnd("compareAndUpdateArrays_ExecutionTime");
    }
    const InitializeMainTable = () => {
        let iheight = GetGridHeight();
        
        RefTableData.current = TableData;
        RefTable.current = table = new Tabulator("#"+state.GridName, {
            pagination: state.pagination,
            paginationSizeSelector: state.paginationSize,
            paginationMode: state.paginationMode,
            height: iheight,
            clipboard: state.clipboard,
            clipboardCopyRowRange:function(){
                //only copy rows to clipboard where the age is over 18
                let dataselrws = table.getSelectedData();
                let selectedrowsidss = dataselrws.map(row => row.id);
                return this.getRows().filter((row) => {
                    if(selectedrowsidss.length === 0) { return true; }
                    else { 
                        if(selectedrowsidss.indexOf(row.getData().id) > -1){
                            row.getElement().classList.remove('mainGridRowStyle');
                            return true;
                        }
                        else{
                            return false;
                        }
                    }
                });
            }, //change default selector to selected
            paginationSize: state.paginationSize[0],
            headerSortClickElement:"icon",
            selectable: state.selectable,
            selectableRangeMode: state.selectableRangeMode,
            data: RefTableData.current, //link data to table
            reactiveData:state.reactiveData, //enable data reactivity
            columns: ColumnModel, //define table columns
            //renderHorizontal:"virtual",
            index: state.index,
            keybindings:{
                "navUp" : false, 
                "navDown": false,
            },
            ajaxLoader:false,
            movableRows: (state.movableRows ? state.movableRows:false),
            renderHorizontal:"virtual",//"virtual",
            renderVertical: "virtual",
            virtualDomBuffer: 500,
            //debug: true,
            //progressiveRender: true,
            placeholder:state.placeholder,
            footerElement: state.footerElement,
            paginationCounter:state.paginationCounter,
            movableColumns:state.movableColumns,
            persistence:{
                sort: false, //persist column sorting
                filter: state.persistence, //persist filters
                headerFilter: state.persistence, //persist header filters
                group: state.persistence, //persist row grouping
                page: state.persistence, //persist page
                columns: false, //persist columns
            },//state.persistence, 
            rowFormatter:function(row){
                try{
                    if(state.ActionRowColoring){

                        let element = row.getElement();
                        let data = row.getData();
                        if ((data.StylCondDev === "StartDept" || data.StylCondDev === "EndDept") || (data.Type === "StartDept" || data.Type === "EndDept")
                         || (data.Type === "StartDepot" || data.Type === "EndDepot")) 
                        {
                            element.style.backgroundColor = "#BF8B19";
                        }
                        else if ((data.StylCondDev === "IdleTime") || (data.Type === "IdleTime"))
                        {

                            element.style.backgroundColor = "#FA7AFC";
                        }
                        else if (data.StylCondDev === "BreakTrip" ||  data.PUPerson === "BreakTrip")
                        {
                            
                            element.style.backgroundColor = "#00FFFF";
                        }
                        else if(data.bPerformed)
                        {
                            element.style.backgroundColor = "#69aadb";
                        }
                        else if(data["Trip Status"] === "NewTrip"){
                            element.style.backgroundColor = "#8CF68C";
                        }

                    }
                    else if(state.GridName !== "tabulator" && state.GridName !== "clusterTableGrid" && state.rowColoring)
                    {
                        let element = row.getElement();
                        let data = row.getData();
                        // console.log(data[state.rowColoring]);
                        for(let i = 0; i < state.rowColoring.length; i++)
                        {
                            if(data[(state.rowColoring[i].col)] !== null && data[(state.rowColoring[i].col)] !== "")
                            {
                                element.style.backgroundColor = state.rowColoring[i].color;
                                element.style.color = "white";
                            }
                        }
                        
                    }
                    else if(state.GridName === "tabulator"){
                        try {
                            if(row.getData()["TripRequestStatus"].toUpperCase() === "LATE"){
                                let element = row.getElement();
                                let lateTrip = props.rowColors.find(item => item.vStatusName === "LateTrip");
                                if (lateTrip) {
                                    element.style.backgroundColor = lateTrip.vHexColorCode;
                                    element.style.color = lateTrip.vHexForeColorCode;
                                }
                            }
                        }
                        catch(e) { }
                    }
                }
                catch(err){console.log(err);}
                
            },
            rowContextMenu: function(e, row){
                try{
                    
                    row.select();
                    let rowMenu = state.contextMenuSetting;
                    let rowData = row.getData();
                    if(state.GridName === "clusterTableGrid"){
                        if(rowData?.PUPerson == "BreakTrip"){
                            rowMenu[1].label = "Delete Break";
                        }
                        else if(rowData?.PUPerson != "BreakTrip"){
                            rowMenu[1].label = "UnRoute";
                        }
                    }
                    if(state.GridName === "tabulator")
                    {
                        if(SelectedRouteT?.current[SelectedRouteT.current.length - 1] ==="C"){
                            rowMenu[16].label = "Add to Cluster";
                        }
                        else if(rowMenu[16]?.label != null || typeof(rowMenu[16]?.label) != "undefined"){
                            rowMenu[16].label = "Add to Route";
                        }
                        
                        if(rowData.TripRequestStatus.toUpperCase() === "NOSHOW" || rowData.TripRequestStatus.toUpperCase() === "NOSHOWED" || 
                            rowData.TripRequestStatus.toUpperCase() === "CANCELLED" || rowData.TripRequestStatus.toUpperCase() === "CANCELLEDARQ" || 
                            rowData.TripRequestStatus.toUpperCase() === "CANCELLEDSRQ"
                        )
                        {
                            if(!(1 in rowMenu))
                            {
                                rowMenu[1] = replacementContextOptions.props[1];
                            }
                            delete rowMenu[0];
                            
                        }
                        else
                        {
                            if(!(0 in rowMenu))
                            {
                                rowMenu[0] = replacementContextOptions.props[0];
                            }
                            delete rowMenu[1];
                        }
                        
                        if(String(rowData.BelongstoSegment).toLowerCase() === "false")
                        {
                            if((8 in rowMenu))
                            {
                                delete rowMenu[8];
                            }
                        }
                        else
                        {
                            if(!(8 in rowMenu))
                            {
                                rowMenu[8] = replacementContextOptions.props[8];
                            }
                        }
                        if(!rowData.Attribute.includes("SR"))
                        {
                            if((4 in rowMenu))
                            {
                                delete rowMenu[4];
                            }
                        }
                        else
                        {
                            if(!(4 in rowMenu))
                            {
                                rowMenu[4] = replacementContextOptions.props[4];
                            }
                        }
                        if(rowData.Route === "")
                        {
                            if((5 in rowMenu))
                            {
                                delete rowMenu[5];
                            }
                            if(!(11 in rowMenu))
                            {
                                rowMenu[11] = replacementContextOptions.props[11];
                            }
                            if(!(15 in rowMenu))
                            {
                                rowMenu[15] = replacementContextOptions.props[15];
                            }
                        }
                        else
                        {
                            if(!(5 in rowMenu))
                            {
                                rowMenu[5] = replacementContextOptions.props[5];
                            }

                            if(rowData.Route.includes("C") || !rowData.Route.includes("RT"))
                            {
                                if(!(11 in rowMenu))
                                {
                                    rowMenu[11] = replacementContextOptions.props[11];
                                }
                                if((15 in rowMenu))
                                {
                                    delete rowMenu[15];
                                }
                            }
                            else
                            {
                                if(!(15 in rowMenu))
                                {
                                    rowMenu[15] = replacementContextOptions.props[15];
                                }
                                if((11 in rowMenu))
                                {
                                    delete rowMenu[11];
                                }
                            }
                        }
                        
                        // if(rowData.Route !== "")
                        // {
                        //     if((16 in rowMenu))
                        //     {
                        //         delete rowMenu[16];
                        //     }
                        // }
                        // else
                        // {
                        //     if(!(16 in rowMenu))
                        //     {
                        //         rowMenu[16] = replacementContextOptions.props[16];
                        //     }
                        // }
        
                    }
                    
                    return rowMenu;
                }
                catch(err){console.log(err);}
                
            },
            // groupBy: (state.groupByColumns && groupingFilterChange.current.toLowerCase() !== "none"  ? function(data){
            //     try{
            //         console.log(groupingFilterChange.current);
            //         return data[groupingFilterChange.current];
            //     }
            //     catch(err){console.log(err);}
                
            // }:false),
        });
        
        table.on("tableBuilt", function(){
            table.on("dataProcessed", function(){
                ApplyPreservedRowsSelection();
            });
            try{ 
                if(state.GridGroupedColumns.length > 0) {
                    let opts = "";
                    state.GridGroupedColumns.forEach(function(col) {
                        opts += "<option value='" +col + "'>" +col + "</option>";
                    });
                    document.getElementById("gridgroupedcolstabulator").innerHTML = opts;
                    document.getElementById("gridgroupedcolstabulator").title = "No Column Grouping";
                    document.getElementById("gridgroupedcolstabulator").addEventListener("change", function(e) {
                        if(RefTable.current !== null)
                        {
                            let groupCol = "No Column Grouping";
                            if(typeof e.target.value == "string"){
                                groupCol = (e.target.value === "" ? "No Column Grouping" : e.target.value);
                            }
                            
                            if(groupCol.toLowerCase() !== "no column grouping")
                            {
                                RefTable.current.setGroupBy(groupCol);
                                document.getElementById("gridgroupedcolstabulator").title = "Group By Col: "+ groupCol;
                                RefTable.current.setGroupStartOpen(true);
                            }
                            else
                            {
                                document.getElementById("gridgroupedcolstabulator").title = "No Column Grouping";
                                RefTable.current.setGroupBy(false);
                            }
                            try{
                                if(typeof props.setGroupingFilter === "function"){
                                    props.setGroupingFilter(groupCol);
                                }
                            }
                            catch(e){

                            }
                        }
                    });
                }
                else{
                    if(document.getElementById("tabulator_group_tabulator") != null) {
                        document.getElementById("tabulator_group_tabulator").style.display = "none";
                    }
                }
            }catch(e) { }
            RefTable.current.setGroupBy(false);
            if(state.ActionList)
            {
                try{

                if(state.GridName === "AgentNotesGrid"){
                    let data = [];
                    document.getElementById("AgentNotesGrid").addEventListener("click", (e) => {
                        if (e.target.id) {
                            // let rowInfo = [];
                            // rowInfo = table.getData();  
                            props.DeleteAgentNotes(e.target.id);

                        }
                    });
                        
                }
                else if(state.GridName === "clusterTableGrid"){
                    let data = [];
                    document.getElementById("clusterTableGrid").addEventListener("click", (e) => {
                        if (e.target.matches('[id*="'+state.GridName+'"]')) {
                            let rowInfo = [];
                            rowInfo = table.getData();
                            if (e.target.id.split("_")[2] == "Break"){
                                for(let t = 0; t < rowInfo.length; t++)
                                {
                                    if(e.target.id.split("_")[3] === String(rowInfo[t].iVehStopOrder) && e.target.id.split("_")[0] === rowInfo[t].TripNo)
                                    {
                                        if(typeof props.AddBreakModalFunc != "undefined"){
                                            props.AddBreakModalFunc(rowInfo[t], rowInfo);
                    
                                        }
                                    }
                                }
                            }
                            let break_trip_key = "";
                            if(e.target.id.split("_")[1] === "PU")
                            {
                                for(let t = 0; t < rowInfo.length; t++)
                                {
                                    if(rowInfo[t].Type.includes("P") && e.target.id.split("_")[0] === rowInfo[t].TripNo)
                                    {
                                        if(e.target.id.split("_")[2] === "UP")
                                        {

                                            if(t !== 0)
                                            {

                                                if (rowInfo[t-1].PUPerson?.toLowerCase() === "sdepot"){

                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevDepotTrip"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;

                                                }

                                                else if(rowInfo[t-1].bWillCall === "true"){

                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevWillCallTrip"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;

                                                }

                                                else if(rowInfo[t-1].bPerformed === "true"){

                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevPerformedStop"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;

                                                }

                                                else if(rowInfo[t].bPerformed === "true"){

                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PerformedStops"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;

                                                }

                                                else if (rowInfo[t].PUPerson?.toLowerCase() === "breaktrip") {

                                                    if (rowInfo[t-1].PUPerson?.toLowerCase() === "breaktrip") {
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevBreakTrip"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
                                                    }

                                                    table.moveRow(rowInfo[t][state.index], rowInfo[t-1][state.index], true);
                                                    table.moveRow(rowInfo[t+1][state.index] , rowInfo[t-1][state.index], true);
                                                    break_trip_key = rowInfo[t].TripNo;

                                                    table.updateData([{ Index: break_trip_key + "_PU", SaveStatus: 1 }]);
                                                    table.updateData([{ Index: break_trip_key + "_DO", SaveStatus: 1 }]);
                                                    var JobID = ServiceStop(break_trip_key, table);
                                                    var selectedRowData = table.getRow(JobID).getData();
                                                    var vAddress = selectedRowData.vAddress;
                                                    var dLatitude = selectedRowData.dLatitude;
                                                    var dLongitude = selectedRowData.dLongitude;
                                                    table.updateData([{ Index: break_trip_key + "_PU", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                    table.updateData([{ Index: break_trip_key + "_DO", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                    ChangeStopOrder(table);
                                                }

                                                else if (rowInfo[t-1].PUPerson?.toLowerCase() === "breaktrip") {  
                                                    break_trip_key = rowInfo[t-1].TripNo;
                                                    if(rowInfo[t].PUPerson?.toLowerCase() != 'breaktrip'){
                                                        table.moveRow(rowInfo[t][state.index], rowInfo[t-2][state.index], true);

                                                        table.updateData([{ Index: break_trip_key + "_PU", SaveStatus: 1 }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", SaveStatus: 1 }]);
                                                        var JobID = ServiceStop(break_trip_key, table);
                                                        var selectedRowData = table.getRow(JobID).getData();
                                                        var vAddress = selectedRowData.vAddress;
                                                        var dLatitude = selectedRowData.dLatitude;
                                                        var dLongitude = selectedRowData.dLongitude;
                                                        table.updateData([{ Index: break_trip_key + "_PU", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        ChangeStopOrder(table);
                                                        break;
                                                    }
                                                    
                                                }

                                                else if(rowInfo[t].TripNo === rowInfo[t-1].TripNo){

                                                    if(rowInfo[t-1].StopType === "DO" && rowInfo[t-1].StopType === "PU"){

                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["DOBeforePU"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;

                                                    }

                                                    table.moveRow(rowInfo[t][state.index], rowInfo[t-1][state.index], true);
                                                    ChangeStopOrder(table);
                                                    break;

                                                }

                                                else{

                                                    table.moveRow(rowInfo[t][state.index], rowInfo[t-1][state.index], true);
                                                    ChangeStopOrder(table);
                                                    break;

                                                }
                                                // let temp = rowInfo[t-1];            //trip before (Added element after last and saved it to local for reloaction after calling reload)
                                                // console.log("trip before", temp);
                                                // rowInfo[t-1] = rowInfo[t];
                                                // rowInfo[t] = temp;
                                                
                                            }
                                            else
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtTop"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                        }
                                        else if(e.target.id.split("_")[2] === "DOWN")
                                        {
                                            if(rowInfo[t+1].TripNo === rowInfo[t].TripNo)
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PUAfterDO"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                            else
                                            {
                                                if(t !== (rowInfo.length-1))
                                                {
                                                    if (rowInfo[t+1].PUPerson?.toLowerCase() === "edepot") {
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextDepotTrip"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
            
            
                                                    }
            
                                                    else if(rowInfo[t+1].bWillCall === "true"){
            
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextvWillCallTrip"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
            
                                                    }
            
                                                    else if(rowInfo[t].bPerformed === "true"){
            
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PerformedStops"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
            
                                                    }
            
                                                    else if(rowInfo[t+1]?.bPerformed === "true"){
            
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextPerformedStop"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
            
                                                    }
        
                                                    else if (rowInfo[t+1].PUPerson?.toLowerCase() == 'breaktrip') {
                                                        break_trip_key = rowInfo[t+1].TripNo;
                                                        if (rowInfo[t].PUPerson?.toLowerCase() != 'breaktrip'){
                                                            table.moveRow(rowInfo[t][state.index], rowInfo[t+2][state.index], false);

                                                        table.updateData([{ Index: break_trip_key + "_PU", SaveStatus: 1 }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", SaveStatus: 1 }]);
                                                        var JobID = ServiceStop(break_trip_key, table);
                                                        var selectedRowData = table.getRow(JobID).getData();
                                                        var vAddress = selectedRowData.vAddress;
                                                        var dLatitude = selectedRowData.dLatitude;
                                                        var dLongitude = selectedRowData.dLongitude;
                                                        table.updateData([{ Index: break_trip_key + "_PU", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        ChangeStopOrder(table)
                                                        break;
        
                                                        } 
                                                    
                                                    }     
                                                    else
                                                    {
                                                        table.moveRow(rowInfo[t+1][state.index], rowInfo[t][state.index], true);
                                                        ChangeStopOrder(table)
                                                        break;
                                                    
                                                    }
                                                }
                                                else
                                                {
                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtBottom"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
                                                }
                                            } 
                                        }
                                        
                                    }
                                }
                                
                            }
                            else if(e.target.id.split("_")[1] === "DO")
                            {
                                
                                for(let t = 0; t < rowInfo.length; t++)
                                {
                                    if(rowInfo[t].Type.includes("D") && e.target.id.split("_")[0] === rowInfo[t].TripNo)
                                    {
                                        if(e.target.id.split("_")[2] === "UP")
                                        {
                                            if(rowInfo[t-1].TripNo === rowInfo[t].TripNo)
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["DOBeforePU"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                            else
                                            {

                                                
                                                if(t !== 0)
                                                {

                                                    if (rowInfo[t-1].PUPerson?.toLowerCase() === "sdepot"){

                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevDepotTrip"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
        
                                                    }
        
                                                    else if(rowInfo[t-1].bWillCall === "true"){
        
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevWillCallTrip"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
        
                                                    }
        
                                                    else if(rowInfo[t-1].bPerformed === "true"){
        
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PerformedStops"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
        
                                                    }
        
                                                    else if(rowInfo[t].bPerformed === "true"){
        
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevPerformedStop"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
        
                                                    }
        
                                                    else if (rowInfo[t-1].PUPerson?.toLowerCase() === "breaktrip") {  
                                                        break_trip_key = rowInfo[t-1].TripNo;
                                                        if(rowInfo[t].PUPerson?.toLowerCase() != 'breaktrip'){
                                                            table.moveRow(rowInfo[t][state.index], rowInfo[t-2][state.index], true);
        
                                                        table.updateData([{ Index: break_trip_key + "_PU", SaveStatus: 1 }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", SaveStatus: 1 }]);
                                                        var JobID = ServiceStop(break_trip_key, table);
                                                        var selectedRowData = table.getRow(JobID).getData();
                                                        var vAddress = selectedRowData.vAddress;
                                                        var dLatitude = selectedRowData.dLatitude;
                                                        var dLongitude = selectedRowData.dLongitude;
                                                        table.updateData([{ Index: break_trip_key + "_PU", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        ChangeStopOrder(table)
                                                        break;
                                                        }
                                                        
                                                    }

                                                    else if(rowInfo[t].TripNo === rowInfo[t-1].TripNo){
        
                                                        if(rowInfo[t-1].StopType === "DO" && rowInfo[t-1].StopType === "PU"){
        
                                                            setModalHeaderText("Cluster Re-arrange Action Alert");
                                                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["DOBeforePU"]);
                                                            setModalBtnText("OK");
                                                            setShowModal(true);
                                                            break;
        
                                                        }
        
                                                    }

                                                    else {

                                                        // let temp = rowInfo[t-1];            //trip before
                                                        // console.log("trip before", temp);
                                                        // rowInfo[t-1] = rowInfo[t];
                                                        // rowInfo[t] = temp;
                                                        table.moveRow(rowInfo[t][state.index], rowInfo[t-1][state.index], true);
                                                        ChangeStopOrder(table)
                                                        break;

                                                    }
                                                    
                                                }
                                                else
                                                {
                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtTop"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
                                                }
                                            }
                                            
                                        }
                                        else if(e.target.id.split("_")[2] === "DOWN")
                                        {
                                            if(t !== (rowInfo.length-1))
                                            {
                                                if (rowInfo[t+1].PUPerson?.toLowerCase() === "edepot") {

                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextDepotTrip"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
        
        
                                                }
        
                                                else if(rowInfo[t+1].bWillCall === "true"){
        
                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextvWillCallTrip"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
        
                                                }
        
                                                else if(rowInfo[t].bPerformed === "true"){
        
                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PerformedStops"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
        
                                                }
        
                                                else if(rowInfo[t+1].bPerformed === "true"){
        
                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextPerformedStop"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
                                                }
                                                //Break Trip
                                                else if (rowInfo[t].PUPerson?.toLowerCase() == 'breaktrip') {
                                                    if (rowInfo[t+1].PUPerson?.toLowerCase() == 'breaktrip') {
                                                        setModalHeaderText("Cluster Re-arrange Action Alert");
                                                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextBreakTrip"]);
                                                        setModalBtnText("OK");
                                                        setShowModal(true);
                                                        break;
                                                    }

                                                    table.moveRow(rowInfo[t][state.index] , rowInfo[t+1][state.index], false);
                                                    table.moveRow(rowInfo[t-1][state.index] , rowInfo[t+1][state.index], false);
                                                    break_trip_key = rowInfo[t].TripNo;

                                                    table.updateData([{ Index: break_trip_key + "_PU", SaveStatus: 1 }]);
                                                    table.updateData([{ Index: break_trip_key + "_DO", SaveStatus: 1 }]);
                                                    var JobID = ServiceStop(break_trip_key, table);
                                                    var selectedRowData = table.getRow(JobID).getData();
                                                    var vAddress = selectedRowData.vAddress;
                                                    var dLatitude = selectedRowData.dLatitude;
                                                    var dLongitude = selectedRowData.dLongitude;
                                                    table.updateData([{ Index: break_trip_key + "_PU", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                    table.updateData([{ Index: break_trip_key + "_DO", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                    ChangeStopOrder(table)
                                                    break;
                                                }

                                                else if (rowInfo[t+1].PUPerson?.toLowerCase() == 'breaktrip') {
                                                    break_trip_key = rowInfo[t+1].TripNo;
                                                    if (rowInfo[t].PUPerson?.toLowerCase() != 'breaktrip'){
                                                        table.moveRow(rowInfo[t][state.index], rowInfo[t+2][state.index], false);

                                                        table.updateData([{ Index: break_trip_key + "_PU", SaveStatus: 1 }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", SaveStatus: 1 }]);
                                                        var JobID = ServiceStop(break_trip_key, table);
                                                        var selectedRowData = table.getRow(JobID).getData();
                                                        var vAddress = selectedRowData.vAddress;
                                                        var dLatitude = selectedRowData.dLatitude;
                                                        var dLongitude = selectedRowData.dLongitude;
                                                        table.updateData([{ Index: break_trip_key + "_PU", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        table.updateData([{ Index: break_trip_key + "_DO", vAddress: vAddress, dLatitude: dLatitude, dLongitude: dLongitude }]);
                                                        ChangeStopOrder(table)

                                                    }
                                                        
                                                }
        
                                                else 
                                                {
                                                    // let temp = rowInfo[t+1];           //trip after
                                                    // console.log("trip after", temp);
                                                    // rowInfo[t+1] = rowInfo[t];
                                                    // rowInfo[t] = temp;
                                                    table.moveRow(rowInfo[t+1][state.index], rowInfo[t][state.index], true);
                                                    ChangeStopOrder(table)
                                                    break;
                                                }
                                            }
                                            else
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtBottom"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                            
                                        }
                                        
                                    }
                                } 
                            }
                            data = table.getData();
                            props.setArrangedClusterTripsFunc(data);
                        }
                    });
                    
                }
                else if(state.GridName === "clientInfoActiveTripsTable")
                {
                    document.getElementById("clientInfoActiveTripsTable").addEventListener("click", (e) => {
                        if (e.target.id) {
                            props.setActiveTripConfirmation(e.target.id);
                        }
                    });
                }
                else{
                    
                    const ArrangeButtons = document.querySelectorAll('[id*="_rearrange'+state.GridName+'"]');
                    ArrangeButtons.forEach((button) => {
                        button.addEventListener("click", (e) => {
                            let rowInfo = [];
                            rowInfo = table.getData();
                            if(e.target.id.split("_")[1] === "PU")
                            {
                                for(let t = 0; t < rowInfo.length; t++)
                                {
                                    if(rowInfo[t].Type.includes("P") && e.target.id.split("_")[0] === rowInfo[t].TripNo)
                                    {
                                        if(e.target.id.split("_")[2] === "UP")
                                        {
                                            
                                            if(t !== 0)
                                            {
                                                // let temp = rowInfo[t-1];            //trip before (Added element after last and saved it to local for reloaction after calling reload)
                                                // console.log("trip before", temp);
                                                // rowInfo[t-1] = rowInfo[t];
                                                // rowInfo[t] = temp;
                                                table.moveRow(rowInfo[t][state.index], rowInfo[t-1][state.index], true);
                                                if(typeof props.setReArrangeFlag === 'function')
                                                {
                                                    props.setReArrangeFlag(true);
                                                }
                                                break;
                                            }
                                            else
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtTop"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                        }
                                        else if(e.target.id.split("_")[2] === "DOWN")
                                        {
                                            if(rowInfo[t+1].TripNo === rowInfo[t].TripNo)
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PUAfterDO"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                            else
                                            {
                                                if(t !== (rowInfo.length-1))
                                                {
                                                    // let temp = rowInfo[t+1];           //trip after
                                                    // console.log("trip after", temp);
                                                    // rowInfo[t+1] = rowInfo[t];
                                                    // rowInfo[t] = temp;
                                                    table.moveRow(rowInfo[t+1][state.index], rowInfo[t][state.index], true);
                                                    if(typeof props.setReArrangeFlag === 'function')
                                                    {
                                                        props.setReArrangeFlag(true);
                                                    }
                                                    break;
                                                }
                                                else
                                                {
                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtBottom"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
                                                }
                                            }
                                            
                                        }
                                        
                                    }
                                }
                                
                            }
                            else if(e.target.id.split("_")[1] === "DO")
                            {
                                
                                for(let t = 0; t < rowInfo.length; t++)
                                {
                                    if(rowInfo[t].Type.includes("D") && e.target.id.split("_")[0] === rowInfo[t].TripNo)
                                    {
                                        if(e.target.id.split("_")[2] === "UP")
                                        {
                                            if(rowInfo[t-1].TripNo === rowInfo[t].TripNo)
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["DOBeforePU"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                            else
                                            {
                                                if(t !== 0)
                                                {
                                                    // let temp = rowInfo[t-1];            //trip before
                                                    // console.log("trip before", temp);
                                                    // rowInfo[t-1] = rowInfo[t];
                                                    // rowInfo[t] = temp;
                                                    table.moveRow(rowInfo[t][state.index], rowInfo[t-1][state.index], true);
                                                    if(typeof props.setReArrangeFlag === 'function')
                                                    {
                                                        props.setReArrangeFlag(true);
                                                    }
                                                    break;
                                                }
                                                else
                                                {
                                                    setModalHeaderText("Cluster Re-arrange Action Alert");
                                                    setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtTop"]);
                                                    setModalBtnText("OK");
                                                    setShowModal(true);
                                                    break;
                                                }
                                            }
                                            
                                        }
                                        else if(e.target.id.split("_")[2] === "DOWN")
                                        {
                                            if(t !== (rowInfo.length-1))
                                            {
                                                // let temp = rowInfo[t+1];           //trip after
                                                // console.log("trip after", temp);
                                                // rowInfo[t+1] = rowInfo[t];
                                                // rowInfo[t] = temp;
                                                table.moveRow(rowInfo[t+1][state.index], rowInfo[t][state.index], true);
                                                if(typeof props.setReArrangeFlag === 'function')
                                                {
                                                    props.setReArrangeFlag(true);
                                                }
                                                break;
                                            }
                                            else
                                            {
                                                setModalHeaderText("Cluster Re-arrange Action Alert");
                                                setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["TripAtBottom"]);
                                                setModalBtnText("OK");
                                                setShowModal(true);
                                                break;
                                            }
                                        }
                                        
                                    }
                                } 
                            }
                        });

                    });
                }

                }
                catch(err){console.log(err);}
            }

            table.on("rowDblClick", async function(e, row){
                SelectedRouteT.current = row.getData().Route;
                state.tableDoubleClickFunc(table, row);
            });

            state.footerElementHandles(table);
            if(state.GridName === "tabulator")
            {
                document.getElementById('tabulator_RefreshData').addEventListener("click", async function(){
                    GridRefreshTimerSecs.current = 0;
                    document.getElementById('tabulator_RefreshData').disabled = true;
                    let _UseInternalGridDataReloadFunction = false;
                    if(typeof props.UseInternalGridDataReloadFunction !=='undefined')
                    {
                        _UseInternalGridDataReloadFunction = props.UseInternalGridDataReloadFunction;
                    }
                    if(_UseInternalGridDataReloadFunction){
                        await PrepareGridRequestDispatch();
                    }
                    else{
                        await RefProps.current.ReloadDataFunction();
                    }
                    document.getElementById('tabulator_RefreshData').disabled = false;
                });
                
            }
        });
        table.on("rowSelectionChanged", function(data, rows){
            if(typeof state.rowSelectionChangeHandle === "function"){
                state.rowSelectionChangeHandle(data);
            }
            if(typeof props.setSelectedRowData === "function"){
                props.setSelectedRowData(table.getSelectedData());
            }
        });
        table.on("rowMoving", function(row){
            try{
                //row - row component
                // console.log("rowMoving", row.getPosition(), "rowIndex", row.getIndex());
                let rowPos = row.getPosition();
                // let rowIndex = row.getIndex();
                let nextRowIndex = row.getNextRow();
                let preRowIndex = row.getPrevRow();
                rowPosDrag.current = rowPos;
                rowIndexDrag.current = nextRowIndex? nextRowIndex.getIndex():preRowIndex.getIndex();
                let tableRowsData = table.getData();
                let willCallRows = [];
                let completedRows = []; 
                let breakTrips = [];
                let depots = [];
                for(let y = 0; y < tableRowsData.length; y++)
                {
                    if(String(tableRowsData[y].bWillCall).toLowerCase() === "true")
                    {
                        willCallRows.push((y+1));
                    }
                    if(tableRowsData[y].bPerformed === "true")
                    {
                        completedRows.push((y+1));
                    }
                    if(tableRowsData[y].PUPerson?.toLowerCase() === 'breaktrip')
                    {
                        breakTrips.push((y+1));
                    }
                    if(tableRowsData[y].Type.toLowerCase().includes("dept") || tableRowsData[y].Type.toLowerCase().includes("depot"))
                    {
                        depots.push((y+1));
                    }
                }
                rowsPosMovementArr.current = [willCallRows, completedRows, breakTrips, depots];
            }
            catch(err){console.log(err);}    
        });
        table.on("rowMoved", function(row){
            //row - row component
            // console.log(row.getPosition(), rowPosDrag, row.getData());
            try{
                RefProps.current.setRowMoveFlag(true);
                let tempRowPos = row.getPosition();
                let rowData = row.getData();
                let tableRowsObj = table.getRows();
                let tableRowsData = table.getData();
                let secondNode = tableRowsObj.find((item)=>item.getData().TripNo === rowData.TripNo && item.getData().Type !== rowData.Type);
                let secondNodePos = secondNode?.getPosition();
                let willCallRows = [];
                let completedRows = [];
                let breakTrips = [];
                let depots = [];
                
                for(let y = 0; y < tableRowsData.length; y++)
                {
                    if(String(tableRowsData[y].bWillCall).toLowerCase() === "true")
                    {
                        willCallRows.push((y+1));
                    }
                    if(String(tableRowsData[y].bPerformed) === "true")
                    {
                        completedRows.push((y+1));
                    }
                    if(tableRowsData[y].PUPerson?.toLowerCase() === 'breaktrip')
                    {
                        breakTrips.push((y+1));
                    }
                    if(tableRowsData[y].Type.toLowerCase().includes("dept") || tableRowsData[y].Type.toLowerCase().includes("depot"))
                    {
                        depots.push((y+1));
                    }
                }
                let newArr = [willCallRows, completedRows, breakTrips, depots];
                let statusArr = [];
                for(let u = 0; u < rowsPosMovementArr.current.length; u++)
                {
                    for(let k = 0; k < newArr.length; k++)
                    {
                        if(rowsPosMovementArr.current[u][k] !== newArr[u][k])
                        {
                            if(u === 0)
                            {
                                if(newArr[u][k] > rowsPosMovementArr.current[u][k])
                                {
                                    statusArr.push({position: newArr[u][k], moved:"before", type:"WC"});
                                }
                                else
                                {
                                    statusArr.push({position: newArr[u][k], moved:"after", type:"WC"});
                                }
                            }
                            else if(u === 1)
                            {
                                if(newArr[u][k] > rowsPosMovementArr.current[u][k])
                                {
                                    statusArr.push({position: newArr[u][k], moved:"before", type:"Performed"});
                                }
                                else
                                {
                                    statusArr.push({position: newArr[u][k], moved:"after", type:"Performed"});
                                }
                            }
                            else if(u === 2)
                            {
                                if(newArr[u][k] > rowsPosMovementArr.current[u][k])
                                {
                                    statusArr.push({position: newArr[u][k], moved:"before", type:"Break"});
                                }
                                else
                                {
                                    statusArr.push({position: newArr[u][k], moved:"after", type:"Break"});
                                }
                            }
                            else if(u === 3)
                            {
                                if(newArr[u][k] > rowsPosMovementArr.current[u][k])
                                {
                                    statusArr.push({position: newArr[u][k], moved:"before", type:"Depot"});
                                }
                                else
                                {
                                    statusArr.push({position: newArr[u][k], moved:"after", type:"Depot"});
                                }
                            }
                        }
                    }
                }        
                let changedValues = []; 
                changedValues = statusArr.length > 0 ? statusArr.filter((item)=>item !== ""):[];
                changedValues = changedValues.length > 0 ? changedValues[(changedValues.length-1)]:[];
                // console.log(changedValues, statusArr);
                // console.log(rowsPosMovementArr.current, newArr, diff);
                // console.log(WCStatus, CompletedStatus, breakTripStatus, depotStatus);
                let statusFlag = "";
                if(rowData.Type === "PU")
                {
                    if(String(rowData.bPerformed) === "true")
                    {
                        row.move(rowIndexDrag.current, true); 
                        setModalHeaderText("Cluster Re-arrange Action Alert");
                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["CompletedTrip"]);
                        setModalBtnText("OK");
                        setShowModal(true);
                        return;
                    }
                    else if(rowData.PUPerson?.toUpperCase() === "BREAKTRIP") //This is assuming breaktrip nodes always stick together, never separate 
                    {
                        //add breaktrip condition
                        // let DORow = row.getNextRow();
                        let DORowPreRowIndex = row.getNextRow().getIndex();
                        // let nextRow = secondNode.getNextRow();
                        let preRow = row.getPrevRow()? row.getPrevRow():row.getNextRow();
                        let preRowData = preRow.getData();
                        // console.log(nextRow.getData());
                        if(tempRowPos > secondNodePos)
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PUAfterDO"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        // else if(Math.abs(tempRowPos - rowPosDrag.current) !== 1)
                        // {
                        //     row.move(rowIndexDrag.current, true); 
                        //     setModalHeaderText("Cluster Re-arrange Action Alert");
                        //     setModalBodyText("Action cannot be done because breaktrips can only move by 1 row.");
                        //     setModalBtnText("OK");
                        //     setShowModal(true);
                        //     return;
                        // }
                        else if(preRowData.Type.toUpperCase() === "STARTDEPT" || preRowData.Type.toUpperCase() === "STARTDEPOT")
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevDepotTrip"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else if(preRowData.PUPerson.toUpperCase() === "BREAKTRIP")
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PrevBreakTrip"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else if(preRowData.iTotalPassengerCount !== 0 && !preRowData.Actions?.includes("Add Break"))
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText("Action cannot be done because previous trip has a passenger.");
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else
                        {
                            // console.log(secondNode.getIndex(), preRow.getIndex(), DORowPreRowIndex, row.getIndex());
                            secondNode.move(DORowPreRowIndex, true);
                            // let data = table.getData();
                            // props.setArrangedClusterTripsFunc(data);
                            // ChangeStopOrder(table);
                            // return;
                        }
                    }
                    else
                    {
                        if(tempRowPos > secondNodePos)
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["PUAfterDO"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else if(changedValues)
                        {
                            if((changedValues.position === (tempRowPos+1)) || (changedValues.position === (tempRowPos-1)))
                            {
                                if(changedValues.type === "WC")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevWillCallTrip"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextvWillCallTrip"];
                                    }
                                }
                                else if(changedValues.type === "Performed")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevPerformedStop"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextPerformedStop"];
                                    }
                                }
                                else if(changedValues.type === "Break")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevBreakTrip"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextBreakTrip"];
                                    }
                                }
                                else if(changedValues.type === "Depot")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevDepotTrip"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextDepotTrip"];
                                    }
                                }
                            } 
                        }
                        
                    }
                }
                else if(rowData.Type === "DO")
                {
                    if(String(rowData.bPerformed) === "true")
                    {
                        row.move(rowIndexDrag.current, true);
                        setModalHeaderText("Cluster Re-arrange Action Alert");
                        setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["CompletedTrip"]);
                        setModalBtnText("OK");
                        setShowModal(true);
                        return;
                    }
                    else if(rowData.PUPerson?.toUpperCase() === "BREAKTRIP") //This is assuming breaktrip nodes always stick together, never separate 
                    {
                        //add breaktrip condition
                        // let PURow = row.getPrevRow();
                        let PURowPreRowIndex = row.getPrevRow().getIndex();
                        let nextRow = row.getPrevRow();
                        let nextRowData = nextRow.getData();
                        // let preRow = row.getPrevRow();
                        // console.log(nextRow.getData());
                        if(tempRowPos <= secondNodePos)
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["DOBeforePU"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        // else if(Math.abs(tempRowPos - rowPosDrag.current) !== 1)
                        // {
                        //     row.move(rowIndexDrag.current, true); 
                        //     setModalHeaderText("Cluster Re-arrange Action Alert");
                        //     setModalBodyText("Action cannot be done because breaktrips can only move by 1 row.");
                        //     setModalBtnText("OK");
                        //     setShowModal(true);
                        //     return;
                        // }
                        else if(nextRowData.Type.toUpperCase() === "ENDDEPT" || nextRowData.Type.toUpperCase() === "ENDDEPOT")
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextDepotTrip"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else if(nextRowData.PUPerson.toUpperCase() === "BREAKTRIP")
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["NextBreakTrip"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else if(nextRowData.iTotalPassengerCount !== 0 && !nextRowData.Actions?.includes("Add Break"))
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText("Action cannot be done because next trip has a passenger.");
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else
                        {
                            // console.log(secondNode.getIndex(), nextRow.getIndex(), PURowPreRowIndex, row.getIndex());
                            secondNode.move(PURowPreRowIndex, false);
                            // let data = table.getData();
                            // props.setArrangedClusterTripsFunc(data);
                            // ChangeStopOrder(table);
                            // return;
                        }
                    }
                    else
                    {
                        if(tempRowPos <= secondNodePos)
                        {
                            row.move(rowIndexDrag.current, true); 
                            setModalHeaderText("Cluster Re-arrange Action Alert");
                            setModalBodyText(state.ArrangeClusterTripsErrorCases[0]["DOBeforePU"]);
                            setModalBtnText("OK");
                            setShowModal(true);
                            return;
                        }
                        else if(changedValues)
                        {
                            if((changedValues.position === (tempRowPos+1)) || (changedValues.position === (tempRowPos-1)))
                            {
                                if(changedValues.type === "WC")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevWillCallTrip"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextvWillCallTrip"];
                                    }
                                }
                                else if(changedValues.type === "Performed")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevPerformedStop"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextPerformedStop"];
                                    }
                                }
                                else if(changedValues.type === "Break")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevBreakTrip"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextBreakTrip"];
                                    }
                                }
                                else if(changedValues.type === "Depot")
                                {
                                    if(changedValues.moved === "before") 
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["PrevDepotTrip"];
                                    }
                                    else
                                    {
                                        statusFlag = state.ArrangeClusterTripsErrorCases[0]["NextDepotTrip"];
                                    }
                                }
                            }
                        }
                        
                    }
                    
                }
                else if(rowData.Type.toUpperCase() === "STARTDEPT" || rowData.Type.toUpperCase() === "ENDDEPT" || 
                    rowData.Type.toUpperCase() === "IDLETIME" || rowData.Type.toUpperCase() === "BREAKTRIP"
                    || rowData.Type.toUpperCase() === "STARTDEPOT" || rowData.Type.toUpperCase() === "ENDDEPOT"
                )
                {
                    if(rowData.Type.toUpperCase() === "ENDDEPT" || rowData.Type.toUpperCase() === "ENDDEPOT")
                    {
                        row.move(rowIndexDrag.current, false);
                        setModalHeaderText("Cluster Re-arrange Action Alert");
                        setModalBodyText(rowData.Type + " row can't be moved.");
                        setModalBtnText("OK");
                        setShowModal(true);
                        return;
                    }
                    else
                    {
                        row.move(rowIndexDrag.current, true);
                        setModalHeaderText("Cluster Re-arrange Action Alert");
                        setModalBodyText(rowData.Type + " row can't be moved.");
                        setModalBtnText("OK");
                        setShowModal(true);
                        return;
                    }
                    
                }
    
                if(statusFlag !== "")
                {
                    row.move(rowIndexDrag.current, true);
                    setModalHeaderText("Cluster Re-arrange Action Alert");
                    setModalBodyText(statusFlag);
                    setModalBtnText("OK");
                    setShowModal(true);
                    return;
                }
                let data = table.getData();
                if(typeof props.setArrangedClusterTripsFunc === 'function')
                {
                    props.setArrangedClusterTripsFunc(data);
                }
                if(state.GridName === "clusterTableGrid")
                {
                    ChangeStopOrder(table);
                }
                else if(typeof props.setReArrangeFlag === 'function')
                {
                    props.setReArrangeFlag(true);
                }
            }
            catch(err){console.log(err);}
        });
        table.on("rowSelected", function(row){
            //row - row component for the selected row
            row.getElement().classList.add('mainGridRowStyle');
        });
        table.on("rowDeselected", function(row){
            //row - row component for the selected row
            row.getElement().classList.remove('mainGridRowStyle');
        });
        table.on("clipboardCopied", function(clipboard) {
            let _UseInternalGridDataReloadFunction = false;
            if(typeof props.UseInternalGridDataReloadFunction !=='undefined')
            {
                _UseInternalGridDataReloadFunction = props.UseInternalGridDataReloadFunction;
            }
            // if(_UseInternalGridDataReloadFunction) {
            //     PrepareGridRequestDispatch();
            // }
            // else{
            //     RefProps.current.ReloadDataFunction();
            // }
            
        });
        table.on("rowMouseOver", function(e, row){

        });
        table.on("rowMouseOut", function(e, row){
           
        });
        table.on("rowClick", function(e, row){
            const rowData = row.getData();
            // console.log(rowData);
            var element = row.getElement();
            if(state.GridName === "tabulator")
            {
                //"#"+state.GridName
                document.addEventListener("keydown", keyPressHandler, false);
            }
            
        });
        if(state.GridName !== "tabulator")
        {
            table.on("groupVisibilityChanged", function(group, visible){
                try{
                    // let groupKey = group.getKey();
                    // if(visible)
                    // {
                    //     // refreshGroupList.current.push(groupKey);
                    //     let tempArr = [...new Set(refreshGroupList.current)];
                    //     refreshGroupList.current = tempArr;
                    //     console.log(refreshGroupList.current);
                    // }
                    // else
                    // {
                    //     // if(refreshGroupList.current.includes(groupKey))
                    //     // {
                    //     //     let index = refreshGroupList.current.indexOf(groupKey);
                    //     //     refreshGroupList.current.splice(index, 1);
                    //     // }
                    // }
                    RefTable.current.rowManager.element.scrollTop = afterRenderScrollerPos.current;

                    
                }
                catch(err){console.log(err);}
            });
            table.on("scrollVertical", function(top){
                verticalPosScroller.current = top;
            });
            table.on("renderStarted", () => {
                try{
                    afterRenderScrollerPos.current = verticalPosScroller.current;
                }
                catch(err){console.log(err);}
            });
            // table.on("scrollHorizontal", function(left){
                
            //     //left - the current horizontal scroll position
            //     setHorizontalScrollerPos(left);
                
            // });
        }

    }

    const ChangeStopOrder = (table) => {
        try {
            var value = 0;
            var _Config = "";
            let tabulatorTripClusterGrid = null;
            tabulatorTripClusterGrid = table;
        
            var tableData = tabulatorTripClusterGrid.getData();
            for (var k = 1; k < tableData.length; k++) {
                if (tableData[k - 1].Type != "IdleTime"){
                    value = value + 1;

                }
                    
        
                tabulatorTripClusterGrid.updateData([{ Index: tableData[k]["Index"], "Stop#": value }]);
            }
        } 
        
        catch (ChangeStopOrder) {}
    }


    function ServiceStop(conf, tableData) {
        var result = tableData.getData()
        let i = result.findIndex((trip) => trip["TripNo"] === conf);
        let j = i;
        let serviceTrip = -1;
        let bServiceTripFound = false;
      
        while (i >= 0) {
          const _StopType = result[i].Type;
          const _PUPerson = result[i].PUPerson;
      
          if (
            (_StopType.toLowerCase() === 'pu' || _StopType.toLowerCase() === 'do') &&
            _PUPerson.toLowerCase() !== 'breaktrip' &&
            _StopType.toLowerCase() !== 'idletime' &&
            _StopType.toLowerCase() !== 'startdept' && _StopType.toLowerCase() !== 'startdepot'
          ) {
            serviceTrip = result[i]["Index"];
            bServiceTripFound = true;
            break;
          }
          i--;
        }
      
        if (!bServiceTripFound) {
          while (j < result.length) {
            const _StopType = result[j].Type;
            const _PUPerson = result[j].PUPerson;
      
            if (
              (_StopType.toLowerCase() === 'pu' || _StopType.toLowerCase() === 'do') &&
              _PUPerson.toLowerCase() !== 'breaktrip' &&
              (_StopType.toLowerCase() !== 'idletime' || _StopType.toLowerCase() !== 'enddept' || _StopType.toLowerCase() !== 'enddepot')
            ) {
              serviceTrip = result[j]["Index"];
              bServiceTripFound = true;
              break;
            }
            j++;
          }
        }
      
        return serviceTrip;
      }
      useEffect( () => {

        if(typeof props.GridColumnSetting !== 'undefined' && props.GridColumnSetting !== null){
            setClusterTableColumnModel(props.GridColumnSetting);
            setBackupTable(props.GridColumnSetting);
        }
      }, [props.GridColumnSetting])
    useEffect( () => {
        try{
            let strData = "";
            if(typeof props.Data === 'object'){
                if(typeof props.Data?.data !== "undefined"){
                    strData = props.Data.data;
                }
            }
    
            if(strData !== "")
            {
                getGridDataFormat(strData);
            }
            else
            {
                if(RefTable.current !== null){
                    RefTable.current.destroy();
                    RefTable.current = null;
                }
                
                let columnModel = [];
                let rowData = [];
                let newData = props.Data;
                
                if(props.Data?.length > 0)
                {
                    if(state.movableRows)
                    {
                        columnModel.push({field: "Drag", rowHandle:true, formatter:"handle", headerSort:state.sortCondition, width:30, minWidth:30, maxWidth:40, hozAlign: "center", visible: true, frozen:true});
                    }
                    if(state.ActionList)
                    {
                        columnModel.push({ title:"Actions", field: "Actions", headerFilter:"input", width:120, minWidth:120, headerSort:state.sortCondition, 
                            headerHozAlign: "center", hozAlign: "center", visible: true, formatter:"html", headerSortTristate:true, frozen:true}
                        );
                    }
                    for(var i = 0; i < Object.keys(props.Data[0]).length; i++)
                    {
                        if(state.CCAddition)
                        {
                            if(state.AlwaysHiddenColumns && state.AlwaysHiddenColumns.indexOf(Object.keys(props.Data[0])[i]) > -1)
                            {
                                columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i], headerFilter:"input", headerSort:state.sortCondition, headerMenu:headerMenu, headerHozAlign: "center", hozAlign: "left", visible: false, headerSortTristate:true});
                            }
                            else
                            {
                                if(state.listofCheckBoxCols && state.listofCheckBoxCols.includes("check") && state.listofCheckBoxCols.includes(Object.keys(props.Data[0])[i]))
                                {
                                    columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i], headerSort:state.sortCondition, headerFilterParams:{"tristate":true}, headerMenu:headerMenu, headerFilter:"tickCross", headerHozAlign: "center", hozAlign: "center", visible: true, headerSortTristate:true, formatter: function(cell){
                                        try{
                                            let value = cell.getValue();
                                            if(typeof value === "string")
                                            {
                                                if(value.toUpperCase() === "TRUE")
                                                {
                                                    return "<input type='checkbox' class='dateCheck' checked disabled/>";
                                                }
                                                else
                                                {
                                                    return "<input type='checkbox' class='dateCheck' disabled/>";
                                                }
                                            }
                                            else
                                            {
                                                if(value)
                                                {
                                                    return "<input type='checkbox' class='dateCheck' checked disabled/>";
                                                }
                                                else
                                                {
                                                    return "<input type='checkbox' class='dateCheck' disabled/>";
                                                }
                                            }
                                        }
                                        catch(err){console.log(err);}
                                    }});
    
                                }
                                else if(state.listofCheckBoxCols && state.listofCheckBoxCols.includes("NA") && state.listofCheckBoxCols.includes(Object.keys(props.Data[0])[i]))
                                {
                                    //Nothing
                                }
                                else if(state.GeneralArrayForHTML && state.GeneralArrayForHTML.includes(Object.keys(props.Data[0])[i])){
                                    columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i].replace(/\./g, ""), headerSort:state.sortCondition, headerFilter:"input", headerHozAlign: "center", headerMenu:headerMenu, hozAlign: "left", visible: true, formatter:"html", headerSortTristate:true});
                                }
                                else if(state.customWidthCols && state.customWidthCols.some(element=>element.includes(Object.keys(props.Data[0])[i])))
                                {
                                    let indexLocation = state.customWidthCols.findIndex(element=>element.includes(Object.keys(props.Data[0])[i]));
                                    let newWidth = state.customWidthCols[indexLocation].split("-")[1];
                                    columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i].replace(/\./g, ""), headerSort:state.sortCondition, headerFilter:"input", width:newWidth, headerHozAlign: "center", headerMenu:headerMenu, hozAlign: "left", visible: true, headerSortTristate:true});
                                }
                                else
                                {
                                    if(Object.keys(props.Data[0])[i].includes("."))
                                    {
                                        columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i].replace(/\./g, ""), headerSort:state.sortCondition, headerFilter:"input", headerHozAlign: "center", headerMenu:headerMenu, hozAlign: "left", visible: true, headerSortTristate:true});
                                    }
                                    else
                                    {
                                        columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i], headerFilter:"input", headerSort:state.sortCondition, headerHozAlign: "center", hozAlign: "left", headerMenu:headerMenu, visible: true, headerSortTristate:true});
                                    }
                                }
                            }  
                        }
                        else
                        {
                            if(state.AlwaysHiddenColumns && state.AlwaysHiddenColumns.indexOf(Object.keys(props.Data[0])[i]) > -1)
                            {
                                columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i], headerFilter:"input", headerSort:state.sortCondition, headerHozAlign: "center", hozAlign: "left", visible: false, headerSortTristate:true});
                            }
                            else
                            {
                                if(state.listofCheckBoxCols && state.listofCheckBoxCols.includes("check") && state.listofCheckBoxCols.includes(Object.keys(props.Data[0])[i]))
                                {
                                    columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i], headerSort:state.sortCondition, headerFilterParams:{"tristate":true}, headerFilter:"tickCross", headerHozAlign: "center", hozAlign: "center", visible: true, headerSortTristate:true, formatter: function(cell){
                                        try{
                                            let value = cell.getValue();
                                            if(typeof value === "string")
                                            {
                                                if(value.toUpperCase() === "TRUE")
                                                {
                                                    return "<input type='checkbox' class='dateCheck' checked disabled/>";
                                                }
                                                else
                                                {
                                                    return "<input type='checkbox' class='dateCheck' disabled/>";
                                                }
                                            }
                                            else
                                            {
                                                if(value)
                                                {
                                                    return "<input type='checkbox' class='dateCheck' checked disabled/>";
                                                }
                                                else
                                                {
                                                    return "<input type='checkbox' class='dateCheck' disabled/>";
                                                }
                                            }
                                        }
                                        catch(err){console.log(err);}
                                    }});

                                }
                                else if(state.listofCheckBoxCols && state.listofCheckBoxCols.includes("NA") && state.listofCheckBoxCols.includes(Object.keys(props.Data[0])[i]))
                                {
                                    //Nothing
                                }
                                else if(state.GeneralArrayForHTML && state.GeneralArrayForHTML.includes(Object.keys(props.Data[0])[i])){
                                    columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i].replace(/\./g, ""), headerSort:state.sortCondition, headerFilter:"input", headerHozAlign: "center", hozAlign: "left", visible: true, formatter:"html", headerSortTristate:true});
                                }
                                else if(state.customWidthCols && state.customWidthCols.some(element=>element.includes(Object.keys(props.Data[0])[i])))
                                {
                                    let indexLocation = state.customWidthCols.findIndex(element=>element.includes(Object.keys(props.Data[0])[i]));
                                    let newWidth = state.customWidthCols[indexLocation].split("-")[1];
                                    columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i].replace(/\./g, ""), headerSort:state.sortCondition, headerFilter:"input", width:newWidth, headerHozAlign: "center", hozAlign: "left", visible: true, headerSortTristate:true});
                                }
                                else
                                {
                                    if(Object.keys(props.Data[0])[i].includes("."))
                                    {
                                        columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i].replace(/\./g, ""), headerSort:state.sortCondition, headerFilter:"input", headerHozAlign: "center", hozAlign: "left", visible: true, headerSortTristate:true});
                                    }
                                    else
                                    {
                                        columnModel.push({ title: Object.keys(props.Data[0])[i], field: Object.keys(props.Data[0])[i], headerSort:state.sortCondition, headerFilter:"input", headerHozAlign: "center", hozAlign: "left", visible: true, headerSortTristate:true});
                                    }
                                }
                            }  
                        }
                        
                    }
                    const seen = new Set();
                    let filteredColModel = columnModel.filter(item => {
                        if(seen.has(item.title))
                        {
                            return false;
                        }
                        else
                        {
                            seen.add(item.title);
                            return true;
                        }
                    })
                    let WC = 0;
                    let AMC = 0;
                    let bBreak = false;

                    for(var j = 0; j < newData.length; j++)
                    {
                        if(state.ActionList)
                        {
                            if(state.GridName === "clusterTableGrid")
                            {
                                if(newData[j].Route !== "" && newData[j].Route !== null)
                                {
                                    if (newData[j].Type.toUpperCase() !== "STARTDEPT" && newData[j].Type.toUpperCase() !== "ENDDEPT" && 
                                        newData[j].Type.toUpperCase() !== "IDLETIME" && newData[j].Type.toUpperCase() !== "BREAKTRIP" && 
                                        newData[j].Type.toUpperCase() !== "STARTDEPOT" && newData[j].Type.toUpperCase() !== "ENDDEPOT" &&
                                        newData[j].PUPerson.toUpperCase() !== "BREAKTRIP" && newData[j].Type.toUpperCase() === "PU") 
                                    {
                                        AMC += parseInt(newData[j].iTotalPassengerCount);
                                        WC += parseInt(newData[j].iTotalWheelChairs);
                                        bBreak = true;
                                    }
                                    else if (newData[j].Type.toUpperCase() !== "STARTDEPT" && newData[j].Type.toUpperCase() !== "ENDDEPT" && 
                                        newData[j].Type.toUpperCase() !== "IDLETIME" && newData[j].Type.toUpperCase() !== "BREAKTRIP" &&
                                        newData[j].Type.toUpperCase() !== "STARTDEPOT" && newData[j].Type.toUpperCase() !== "ENDDEPOT" &&  
                                        newData[j].PUPerson.toUpperCase() !== "BREAKTRIP" && newData[j].Type.toUpperCase() === "DO") 
                                    {
                                        AMC -= parseInt(newData[j].iTotalPassengerCount);
                                        WC -= parseInt(newData[j].iTotalWheelChairs);
                                        bBreak = true;
                                    }
                                    // if (newData[j].Type.toUpperCase() !== "STARTDEPT" && newData[j].Type.toUpperCase() !== "ENDDEPT" && newData[j].Type.toUpperCase() !== "IDLETIME" && newData[j].Type.toUpperCase() !== "BREAKTRIP"  && newData[j].PUPerson.toUpperCase() !== "BREAKTRIP" && WC + AMC === 0 && bBreak === true) {
                                        
                                        
                                    // }
                                }
                                if(newData[j].Type.toUpperCase() === "PU" && newData.length > 2)
                                {
                                    if(String(newData[j].bPerformed).toLowerCase() === "false")
                                    {
                                        if(newData[j].Type.toUpperCase() !== "STARTDEPT" && newData[j].Type.toUpperCase() !== "ENDDEPT" && 
                                        newData[j].Type.toUpperCase() !== "STARTDEPOT" && newData[j].Type.toUpperCase() !== "ENDDEPOT" && 
                                        newData[j].Type.toUpperCase() !== "IDLETIME" && newData[j].Type.toUpperCase() !== "BREAKTRIP" && 
                                        newData[j].PUPerson.toUpperCase() !== "BREAKTRIP" && WC + AMC === 0 && bBreak === true)
                                        {
                                            let PUArrows = "<img class='float-start' id='"+newData[j].TripNo+"_PU_UP_rearrange"+
                                            state.GridName+"' style='cursor:pointer !important;' title='Move P"+newData[j]["Stop#"]+
                                                " Up' src='"+arrowUp+"'><img class='float-center' id='"+newData[j].TripNo+"_PU_DOWN_rearrange"+state.GridName+
                                                "' style='cursor:pointer !important;' title='Move P"+newData[j]["Stop#"]+ " Down' src='"+arrowDown+"'>";
                                            newData[j].Actions = PUArrows;
                                            let addbreaktriparrow = "<img class='float-end' id='"+newData[j].TripNo+
                                                "_PU_Break_"+newData[j].iVehStopOrder+ "_" + state.GridName+"' style='cursor:pointer !important;' title='Add Break' src='"+
                                                addbreaktripIcon+"'>";
                                            newData[j].Actions += addbreaktriparrow;
                                        }
                                        else if (newData[j].PUPerson?.toUpperCase() === "BREAKTRIP") {
                                            if (newData[j].Type === "PU") {
                                                let PUArrows = "<div class='col' style='width:61%'><img class='float-start' id='"+newData[j].TripNo+"_PU_UP_rearrange"+state.GridName+
                                                "' style='cursor:pointer !important;' title='Move P"+newData[j]["Stop#"]+ " Up' src='"+arrowUp+"'></div>";
                                                newData[j].Actions = PUArrows;

                                            }
                                            
                                        }
                                        else
                                        {
                                            let PUArrows = "<div class='col' style='width:61%'><img class='float-start' id='"+newData[j].TripNo+"_PU_UP_rearrange"+state.GridName+
                                                "' style='cursor:pointer !important;' title='Move P"+newData[j]["Stop#"]+ " Up' src='"+arrowUp+"'><img class='float-end' id='"
                                                +newData[j].TripNo+"_PU_DOWN_rearrange"+state.GridName+"' style='cursor:pointer !important;' title='Move P"+newData[j]["Stop#"]+
                                                " Down' src='"+arrowDown+"'></div>";
                                            newData[j].Actions = PUArrows;
                                        }
                                    }
                                    
                                }
                                else if(newData[j].Type.toUpperCase() === "DO" && newData.length > 2)
                                {
                                    if(String(newData[j].bPerformed).toLowerCase() === "false")
                                    {
                                        if(newData[j].Type.toUpperCase() !== "STARTDEPT" && newData[j].Type.toUpperCase() !== "ENDDEPT" && 
                                        newData[j].Type.toUpperCase() !== "STARTDEPOT" && newData[j].Type.toUpperCase() !== "ENDDEPOT" && 
                                        newData[j].Type.toUpperCase() !== "IDLETIME" && newData[j].Type.toUpperCase() !== "BREAKTRIP" && 
                                        newData[j].PUPerson.toUpperCase() !== "BREAKTRIP" && WC + AMC === 0 && bBreak === true)
                                        {
                                            let DOArrows = "<img class='float-start' id='"+newData[j].TripNo+"_DO_UP_rearrange"+
                                                state.GridName+"' style='cursor:pointer !important;' title='Move D"+newData[j]["Stop#"]+ " Up' src='"+
                                                arrowUp+"'><img class='float-center' id='"+newData[j].TripNo+"_DO_DOWN_rearrange"+state.GridName+
                                                "' style='cursor:pointer !important;' title='Move D"+newData[j]["Stop#"]+ " Down' src='"+arrowDown+"'>";
                                            newData[j].Actions = DOArrows;
                                            let addbreaktriparrow = "<img class='float-end' id='"+newData[j].TripNo+"_DO_Break_"+
                                                newData[j].iVehStopOrder+ "_" +state.GridName+"' style='cursor:pointer !important;' title='Add Break' src='"
                                                +addbreaktripIcon+"'>";
                                            newData[j].Actions += addbreaktriparrow;
                                        }

                                        else if(newData[j].PUPerson?.toUpperCase() === "BREAKTRIP"){

                                            if (newData[j].Type === "DO"){
                                                let DOArrows = "<div class='col' style='width:61%'><img class='float-start' id='"
                                                +newData[j].TripNo+"_DO_DOWN_rearrange"+state.GridName+"' style='cursor:pointer !important;' title='Move D"+newData[j]["Stop#"]+
                                                " Down' src='"+arrowDown+"'></div>";
                                                newData[j].Actions = DOArrows;
                                            }
                                        }

                                        else
                                        {
                                            let DOArrows = "<div class='col' style='width:61%'><img class='float-start' id='"+newData[j].TripNo+"_DO_UP_rearrange"+state.GridName+
                                                "' style='cursor:pointer !important;' title='Move D"+newData[j]["Stop#"]+ " Up' src='"+arrowUp+"'><img class='float-end' id='"
                                                +newData[j].TripNo+"_DO_DOWN_rearrange"+state.GridName+"' style='cursor:pointer !important;' title='Move D"+newData[j]["Stop#"]+
                                                        " Down' src='"+arrowDown+"'></div>";
                                            newData[j].Actions = DOArrows;
                                        }
                                    }    
                                }
                                        
                            }
                            else if(state.GridName === "AgentNotesGrid"){
                                let DelteIcon = "<div id='"+newData[j].iID+"' style='cursor:pointer !important;' title='Delete Notes'>" +
                                                "<svg id='" + newData[j].iID + "' width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>" +
                                                "<rect width='20' height='20' x='2' y='2' rx='2' ry='2'></rect>" +
                                                "<path d='M6 18L18 6M6 6l12 12'></path>" +
                                                "</svg>" +
                                                "</div>";

                                newData[j].Actions = DelteIcon;
                                
                            }
                            else if(state.GridName === "clientInfoActiveTripsTable")
                            {
                                
                                let rejectTripBtn = 
                                    "<button id='"+newData[j].iRefId+"' title='Cancel active trip #"+newData[j].iRefId+"' class='bg-danger rounded border-0 text-white'>Cancel</button>"
                                ;
                                let copyRideBtn = 
                                    "<button id='"+newData[j].iRefId+"_copy' title='Copy active trip #"+newData[j].iRefId+"' class='mx-1 bg-dark rounded border-0 text-white'>Copy</button>"
                                ;
                                newData[j].Actions = rejectTripBtn + copyRideBtn;
                            }
                            else
                            {
                                if(newData[j].Type.toUpperCase() === "PU" && newData.length > 2)
                                {
                                    
                                    let PUArrows = "<img class='float-start' id='"+newData[j].TripNo+"_PU_UP_rearrange"+
                                        state.GridName+"' style='cursor:pointer !important;' title='Move P"+newData[j]["Stop#"]+ " Up' src='"+
                                        arrowUp+"'><img class='float-end' id='"+newData[j].TripNo+"_PU_DOWN_rearrange"+state.GridName+
                                        "' style='cursor:pointer !important;' title='Move P"+newData[j]["Stop#"]+ " Down' src='"+arrowDown+"'>";
                                    newData[j].Actions = PUArrows;
                                }
                                else if(newData[j].Type.toUpperCase() === "DO" && newData.length > 2)
                                {
                                    let DOArrows = "<img class='float-start' id='"+newData[j].TripNo+"_DO_UP_rearrange"+
                                        state.GridName+"' style='cursor:pointer !important;' title='Move D"+newData[j]["Stop#"]+ " Up' src='"+
                                        arrowUp+"'><img class='float-end' id='"+newData[j].TripNo+"_DO_DOWN_rearrange"+state.GridName+
                                        "' style='cursor:pointer !important;' title='Move D"+newData[j]["Stop#"]+ " Down' src='"+arrowDown+"'>";
                                    newData[j].Actions = DOArrows;
                                }
                            }

                        }
                        Object.keys(newData[j]).forEach((key)=>{
                            if(key.includes("."))
                            {
                                let newkey = key.replace(/\./g, "");
                                newData[j][newkey] = newData[j][key];
                                delete newData[j][key];
                            }
                        });
                        rowData.push(newData[j]);
                    }   
                    // console.log(props.GridColumnSetting)
                    if(props.GridColumnSetting)
                    {
                        for (let i = 0; i < props.GridColumnSetting.length; i++){
                            for (let j = 0; j < filteredColModel.length; j++){
                                if(props.GridColumnSetting[i]["vName"].slice(3) == filteredColModel[j]["field"]){
                                    filteredColModel[j]["width"]=props.GridColumnSetting[i]["width"];
                                    filteredColModel[j]["visible"]=props.GridColumnSetting[i]["bVisible"];
                                }
    
                            }
                        }
                        filteredColModel = sortArray(filteredColModel, props.GridColumnSetting);
                    }

                    setColumnModel(filteredColModel);
                    setTableData(rowData);
                }
                
                
            }
            window.addEventListener('resize', handleResize);
        }
        catch(err){console.log(err);}
        
    }, [props.Data, props.MapDetailData]);

    function sortArray(actualArray, orderArray, CustomsColumns= ["Drag","Actions"]) {
        const orderMap = {};
        orderArray.forEach(item => {
            if(item["vName"].substring(0, 3) == "col"){
                orderMap[item["vName"].substring(3, 999)] = (parseInt(item["iVisibleIndex"]) +  CustomsColumns.length);
            }
            else{
                orderMap[item["vName"]] = (parseInt(item["iVisibleIndex"]) +  CustomsColumns.length);
            }
        });
        for (let i = 0; i < CustomsColumns.length; i++) {
            let columnName = CustomsColumns[i];
            orderMap[columnName] = i;
        }
        actualArray.sort(function(a, b) {
            const aOrder = orderMap[a.field] !== undefined ? orderMap[a.field] : 999;
            const bOrder = orderMap[b.field] !== undefined ? orderMap[b.field] : 999;
 
            if (aOrder === -1) return 1;  // Move a to the end if its order is -1
            if (bOrder === -1) return -1; // Move b to the end if its order is -1
            
            return aOrder - bOrder; // Sort based on the orderMap values
        });
    
        return actualArray;
    }

    useEffect( () => {
        try{
            if(RefTable.current == null && ColumnModel.length > 0) {
                InitializeMainTable();
                if(typeof props.GridLoadComplete !== "undefined"){
                    props.GridLoadComplete();
                }
            }
        }
        catch(err){console.log(err);}
        
        // else if(RefTable.current != null && TableData.length > 0){
        //     RefTable.current.replaceData(TableData);
        //     props.GridLoadComplete();
        // }
        //table.replaceData(TableData);
        //RefProps.current = props;
    }, [TableData]);

    useEffect( () => {
        let interval;
        try{
            if(state.intervalEnable)
            {
                interval = setInterval( function(){ 
                    if(RefTable.current !== null) {
                        GridRefreshTimerSecs.current = GridRefreshTimerSecs.current + 1;
                        if((GridRefreshTimerSecs.current * 1000) > state.intervalTimer){
                            GridRefreshTimerSecs.current = 0;
                            if(document.getElementsByClassName("tabulatorProgressBar")[0])
                            {
                                document.getElementsByClassName("tabulatorProgressBar")[0].setAttribute('aria-valuenow',0);
                                document.getElementsByClassName("tabulatorProgressBar")[0].style.width = "0%";
                            }
                            setProgressBarCurrentValue(0);
                            let _UseInternalGridDataReloadFunction = false;
                            if(typeof props.UseInternalGridDataReloadFunction !=='undefined')
                            {
                                _UseInternalGridDataReloadFunction = props.UseInternalGridDataReloadFunction;
                            }
                            if(_UseInternalGridDataReloadFunction){
                                PrepareGridRequestDispatch();
                            }
                            else{
                                RefProps.current.ReloadDataFunction();
                            }
                        }
                        else{
                            if(GridRefreshTimerSecs.current % 1 === 0) {
                                let progressvaltemp = Math.round(((GridRefreshTimerSecs.current / (state.intervalTimer / 1000)) * 100), 0);
                                if(document.getElementsByClassName("tabulatorProgressBar")[0])
                                {
                                    document.getElementsByClassName("tabulatorProgressBar")[0].setAttribute('aria-valuenow', progressvaltemp);
                                    document.getElementsByClassName("tabulatorProgressBar")[0].style.width = progressvaltemp+"%";
                                }
                                
                                setProgressBarCurrentValue(progressvaltemp);
                                let progressbarlabel="";
                                progressbarlabel = Math.round(((state.intervalTimer/1000) - GridRefreshTimerSecs.current), 0);
                                if(progressbarlabel === 0){
                                    if(document.getElementsByClassName("tabulatorProgressBar")[0])
                                    {
                                        document.getElementsByClassName("tabulatorProgressBar")[0].textContent = "reloading";
                                    }
                                    setProgressBarCurrentLabel("reloading");
                                }
                                else{
                                    progressbarlabel = "" + progressbarlabel + "s";
                                    if(document.getElementsByClassName("tabulatorProgressBar")[0])
                                    {
                                        document.getElementsByClassName("tabulatorProgressBar")[0].textContent = progressbarlabel;
                                    }
                                    setProgressBarCurrentLabel(progressbarlabel);
                                }
                            }
                        }
                    }
                }, 1000);
            }
            return () => {
                window.removeEventListener('resize', handleResize);
                document.removeEventListener("keydown", keyPressHandler, false);
                // try{
                //     RefTable.current.destroy();
                // }
                // catch(e) { }
                if(state.intervalEnable)
                {
                    clearInterval(interval);
                }
            };
        }
        catch(err){console.log(err);}
        
    }, [RefTable.current, props.UserRequestParameters]);
    
    useEffect(()=>{
        RefProps.current = props;
        const handleResizeTable = () =>{
            if(RefTable.current && state.GridName === "tabulator")
            {
                let newHeight = (window.innerHeight - state.heightoffset);
                RefTable.current.setHeight(newHeight);
            }
        };
        window.addEventListener('resize', handleResizeTable);
        return () => {
            window.removeEventListener('resize', handleResizeTable);
        };
    }, []);
    // useEffect(()=>{
    //     if(typeof )
    //     props.setArrangedClusterTripsFunc(RefClusterChangeData.current);
    // },[RefClusterChangeData]);
    // useEffect( () => {
    //     if(RefTable.current !== null)
    //     {
    //         let groupCol = (props.groupingFilter === undefined ? "No Column Grouping":props.groupingFilter);
            
    //         if(groupCol.toLowerCase() !== "no column grouping")
    //         {
    //             RefTable.current.setGroupBy(groupCol);
    //             RefTable.current.setGroupStartOpen(true);
    //         }
    //         else
    //         {
    //             RefTable.current.setGroupBy(false);
    //         }
    //     }
    // }, [props.groupingFilter]);
    
    return (
         <Col xs={12} className={state.containerClass}  style={{ top: -6, height: props.height, padding: 0,  ...(WidthFromParent ? { width: WidthFromParent } : {}),}} id={state.GridName+"_container"}>
            <div id={state.GridName} className='border border-dark' style={{height: '90%'}} ref={RefGridMainDiv}></div>
            {/* {state.EnableProgressBar ? <ProgressBar animated  now={ProgressBarCurrentValue} style={{position:'absolute', bottom: '46px', right:'330px', width:'100px'}} label={ProgressBarCurrentLabel}/> :""} */}
            {props.ShowLoader || ShowGridLoader ? <div className="loader" id ={state.GridName+"_loader"}></div> : ""}
            {showModal ? <Modal centered backdrop="static" keyboard={true} onHide={handleModalClose} show={showModal} animation={true}>
                            <Modal.Header closeButton>
                                <Modal.Title className='user-select-none'>{modalHeaderText}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className='user-select-none'>{modalBodyText}</Modal.Body>
                            <Modal.Footer>
                                <Button variant="dark" onClick={handleModalClose}>
                                {modalBtnText}
                                </Button>
                            </Modal.Footer>
                        </Modal>: ""}
        
            
            
        </Col>

        
        
    );
});

export default GridControl;